<template>
  <div>
  <fieldset class="natural-survey-fieldset mt-1">
    <legend class="natural-survey-fieldset__legend">الاحداثيات والخريطة</legend>
    <div class="natural-survey-fieldset__body survey-map-wrapper mt-1">
        

        <!-- <small class="text-muted d-block mb-1">
          يمكنك الرسم من أدوات ArcGIS (نقطة / خط / مضلع). سيتم حفظ المضلع للموقع المحدد.
        </small> -->
        <div class="import-files-panel mb-1">
          <!-- <div class="d-flex align-items-center mb-50">
            <strong class="mr-1">استيراد النقاط:</strong>
            <b-spinner v-if="importingMapFiles" small variant="primary" />
          </div> -->
          <!-- <div class="import-files-grid">
            <label class="import-file-item">
              <span>Import KML</span>
              <input type="file" accept=".kml" :disabled="importingMapFiles" @change="onImportFileChange('kml', $event)">
            </label>
            <label class="import-file-item">
              <span>Import KMZ</span>
              <input type="file" accept=".kmz" :disabled="importingMapFiles" @change="onImportFileChange('kmz', $event)">
            </label>
          </div> -->
          <div class="geodesia-survey-import-panel w-100 mt-1">
            <div class="d-flex flex-wrap align-items-start geodesia-survey-import-actions">
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('jxl')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'jxl'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد JXL
                </b-button>
                <small
                  v-if="project && project.has_jxl"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على JXL
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط JXL على الخريطة'"
                    @click="handleProjectSurveyFilePreview('jxl')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'jxl'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('rw5')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'rw5'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد RW5
                </b-button>
                <small
                  v-if="project && project.has_rw5"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على RW5
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط RW5 على الخريطة'"
                    @click="handleProjectSurveyFilePreview('rw5')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'rw5'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('raw')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'raw'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد RAW
                </b-button>
                <small
                  v-if="project && project.has_raw"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على RAW
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط RAW على الخريطة'"
                    @click="handleProjectSurveyFilePreview('raw')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'raw'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="showGeodesiaSheetImportModal = true"
                >
                  <feather-icon
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد Excel (Trimble)
                </b-button>
                <small
                  v-if="project && project.has_geodesia_sheet"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على Geodesia Sheet
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط geodesia sheet على الخريطة'"
                    @click="handleProjectSurveyFilePreview('geodesia_sheet')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'geodesia_sheet'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('kmz')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kmz'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد KMZ
                </b-button>
                <small
                  v-if="project && project.has_jxl"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على KMZ
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط KMZ على الخريطة'"
                    @click="handleProjectSurveyFilePreview('kmz')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'kmz'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('kml')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kml'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد KML
                </b-button>
                <small
                  v-if="project && project.has_jxl"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على KML
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط KML على الخريطة'"
                    @click="handleProjectSurveyFilePreview('kmz')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'kml'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
              <div class="geodesia-survey-import-item">
                <b-button
                  variant="success"
                  size="sm"
                  class="geodesia-survey-import-button"
                  :disabled="importingGeodesiaSurveyFile"
                  @click="handleGeodesiaImportClick('dxf')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'dxf'"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  استيراد DXF
                </b-button>
                <small
                  v-if="project && project.has_jxl"
                  class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    size="12"
                    class="mr-1"
                  />
                  يحتوي على DXF
                  <b-button
                    variant="link"
                    size="sm"
                    class="geodesia-survey-preview-button p-0 ml-50"
                    :disabled="importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                    :title="'عرض نقاط DXF على الخريطة'"
                    @click="handleProjectSurveyFilePreview('dxf')"
                  >
                    <b-spinner
                      v-if="previewingProjectSurveyFileType === 'dxf'"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="EyeIcon"
                      size="14"
                    />
                  </b-button>
                </small>
              </div>
            </div>
            <input
              ref="geodesiaJxlFileInput"
              type="file"
              accept=".jxl"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('jxl', $event)"
            >
            <input
              ref="geodesiaRw5FileInput"
              type="file"
              accept=".rw5"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('rw5', $event)"
            >
            <input
              ref="geodesiaRawFileInput"
              type="file"
              accept=".raw"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('raw', $event)"
            >
            <input
              ref="geodesiaKmzFileInput"
              type="file"
              accept=".kmz"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('kmz', $event)"
            >
            <input
              ref="geodesiaKmlFileInput"
              type="file"
              accept=".kml"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('kml', $event)"
            >
            <input
              ref="geodesiaDxfFileInput"
              type="file"
              accept=".dxf"
              class="d-none"
              @change="onGeodesiaSurveyFileSelected('dxf', $event)"
            >
          </div>
        </div>
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
          <div class="d-flex align-items-center flex-wrap">
            <label class="mb-0 mr-1 font-weight-bold">القطعة:</label>
            <b-form-select
              v-model="selectedLocationId"
              :options="locationOptions"
              class="location-select"
              :disabled="loadingLocations || !locationOptions.length"
              @change="onSelectedLocationChange"
            />
            
          </div>
          <div class="d-flex align-items-center">
            <b-spinner v-if="loadingLocations || savingCoordinates" small class="mr-1" />
            <b-button
              size="sm"
              variant="primary"
              :disabled="!selectedLocationId || !pendingPolygonCoordinates.length || savingCoordinates"
              @click="saveDrawnCoordinates"
            >
              حفظ المضلع المرسوم
            </b-button>
            <b-button
              size="sm"
              variant="outline-success"
              class="ml-1"
              :disabled="loadingLocations || savingCoordinates || addingLocation"
              @click="openAddLocationModal"
            >
              إضافة موقع جديد
            </b-button>
            <b-button
              size="sm"
              variant="outline-warning"
              class="ml-1"
              :disabled="!selectedLocation || loadingLocations || savingCoordinates || addingLocation"
              @click="openEditLocationModal"
            >
              تعديل القطعة
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              class="ml-1"
              :disabled="!selectedLocation || loadingLocations || savingCoordinates || addingLocation || deletingLocation"
              @click="deleteSelectedLocation"
            >
              <b-spinner v-if="deletingLocation" small class="mr-50" />
              حذف القطعة
            </b-button>
          </div>
        </div>
        <div class="map-container-wrapper">
          <div ref="mapContainer" class="natural-survey-map" />
          <!-- <div v-if="loadingMapData" class="map-loading-overlay">
            <b-spinner variant="primary" class="mr-50" />
            <span>جاري تحميل بيانات الخريطة...</span>
          </div> -->
        </div>
        <div
          class="d-flex flex-wrap gap-2 mt-1"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            class="ml-1"
            :disabled="!selectedLocationId || loadExportKml"
            @click="exportKml(selectedLocationId)"
          >
            <span v-if="!loadExportKml">Export KML</span>
            <b-spinner
              v-else
              small
            />
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-1"
            :disabled="!selectedLocationId || loadExportExcel"
            @click="exportExcel(selectedLocationId)"
          >
            <span v-if="!loadExportExcel">Export Excel</span>
            <b-spinner
              v-else
              small
            />
          </b-button>
          <b-button
            v-if="showJxlDownload && hasPermission('generate jxlFiles')"
            size="sm"
            variant="outline-secondary"
            :disabled="downloadingJxl"
            v-b-tooltip.hover.top="'تنزيل JXL (Trimble / JobXML) لهذه القطعة'"
            @click="downloadCoordinatesJxl"
          >
            <b-spinner
              v-if="downloadingJxl"
              small
              class="mr-1"
            />
            <span v-else> <feather-icon icon="DownloadIcon" size="14"/> JXL </span>
          </b-button>
          <b-button
            v-if="hasPermission('generate shapefile')"
            size="sm"
            variant="outline-warning"
            :disabled="downloadingShapeZip"
            v-b-tooltip.hover.top="'Download Shape ZIP for this project'"
            @click="openShapeSchemaModal"
          >
            <b-spinner
              v-if="downloadingShapeZip"
              small
              class="mr-1"
            />
            <span v-else>Generate Shape ZIP</span>
          </b-button>
          <b-button
            v-if="hasPermission('generate shapefile')"
            size="sm"
            variant="outline-info"
            class="ml-1"
            :disabled="!canDownloadGeodesiaSheetShape || downloadingGeodesiaSheetShapeZip"
            v-b-tooltip.hover.top="'تصدير شيت جيوديسيا (Shapefile)'"
            @click="openGeodesiaSheetShapeModal"
          >
            <b-spinner
              v-if="downloadingGeodesiaSheetShapeZip"
              small
              class="mr-1"
            />
            <span v-else>تحميل شيب جيوديسيا</span>
          </b-button>
          <b-button
            v-if="hasPermission('view projects')"
            size="sm"
            variant="outline-dark"
            class="ml-1"
            :disabled="exportingDxf"
            v-b-tooltip.hover.top="'تصدير ملف أوتوكاد (DXF)'"
            @click="openDxfExportModal"
          >
            <b-spinner
              v-if="exportingDxf"
              small
              class="mr-1"
            />
            <span v-else>
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              تصدير DXF
            </span>
          </b-button>
        </div>
      </div>
  </fieldset>

    <b-modal
      v-model="showDxfExportModal"
      title="تصدير ملف أوتوكاد (DXF)"
      scrollable
      :no-close-on-backdrop="exportingDxf"
      :no-close-on-esc="exportingDxf"
      @hidden="resetDxfExportValidation"
    >
      <div :class="{ 'opacity-50': exportingDxf }">
        <fieldset :disabled="exportingDxf">
          <h6 class="font-weight-bold mb-1">نوع الهندسة</h6>
          <div class="dxf-export-checkbox-row d-flex flex-wrap align-items-center mb-50">
            <b-form-checkbox
              v-model="dxfExportGeometrySelectAll"
              inline
              class="mb-0 ml-2"
              @change="onDxfExportGeometrySelectAllChange"
            >
              تحديد الكل
            </b-form-checkbox>
            <b-form-checkbox
              v-for="opt in dxfGeometryOptions"
              :key="`dxf-geom-${opt.value}`"
              v-model="dxfExportGeometryChecked[opt.value]"
              inline
              class="mb-0 ml-2"
              @change="syncDxfExportGeometrySelectAll"
            >
              {{ opt.label }}
            </b-form-checkbox>
          </div>
          <small class="text-muted d-block mb-1">اختر نوعاً واحداً على الأقل</small>

          <h6 class="font-weight-bold mb-1 mt-1">مصدر البيانات</h6>
          <div class="dxf-export-checkbox-row d-flex flex-wrap align-items-center mb-50">
            <b-form-checkbox
              v-model="dxfExportLayersSelectAll"
              inline
              class="mb-0 ml-2"
              @change="onDxfExportLayersSelectAllChange"
            >
              تحديد الكل
            </b-form-checkbox>
            <b-form-checkbox
              v-for="opt in dxfLayerOptions"
              :key="`dxf-layer-${opt.value}`"
              v-model="dxfExportSourceLayersChecked[opt.value]"
              inline
              class="mb-0 ml-2"
              @change="syncDxfExportLayersSelectAll"
            >
              {{ opt.label }}
            </b-form-checkbox>
          </div>
          <small class="text-muted d-block mb-1">اختر مصدراً واحداً على الأقل</small>

          <h6 class="font-weight-bold mb-1 mt-1">خيارات</h6>
          <b-form-checkbox v-model="dxfExportIncludeCartouche">
            إضافة خرطوشة (إطار ومعلومات المشروع)
          </b-form-checkbox>
        </fieldset>

        <b-alert
          v-if="dxfExportValidationError"
          show
          variant="warning"
          class="mt-1 mb-0"
        >
          {{ dxfExportValidationError }}
        </b-alert>
        <p
          v-if="exportingDxf"
          class="text-primary small mt-1 mb-0"
        >
          <b-spinner small class="mr-50" />
          جاري إنشاء ملف DXF…
        </p>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="ml-1"
            :disabled="exportingDxf"
            @click="showDxfExportModal = false"
          >
            إلغاء
          </b-button>
          <b-button
            variant="primary"
            :disabled="!canConfirmDxfExport || exportingDxf"
            @click="confirmDxfExport"
          >
            <b-spinner
              v-if="exportingDxf"
              small
              class="mr-50"
            />
            تصدير
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="showGeodesiaSheetShapeModal"
      title="تصدير شيت جيوديسيا (Shapefile)"
      ok-title="تحميل"
      cancel-title="إلغاء"
      :ok-disabled="downloadingGeodesiaSheetShapeZip"
      @ok="confirmGeodesiaSheetShapeDownload"
    >
      <b-form-group label="نظام الإحداثيات">
        <b-form-select
          v-model="geodesiaSheetShapeType"
          :options="geodesiaSheetShapeTypeOptions"
          :disabled="downloadingGeodesiaSheetShapeZip"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      v-model="showShapeSchemaModal"
      title="Generate Shape ZIP"
      ok-title="Generate"
      cancel-title="Cancel"
      :ok-disabled="downloadingShapeZip || shapeSchemasLoading"
      @shown="loadShapeSchemasForExport"
      @ok="confirmShapeZipDownload"
    >
      <b-form-group label="Schema (Optional)">
        <b-form-select
          v-model="selectedShapeSchemaId"
          :options="shapeSchemaOptions"
          :disabled="shapeSchemasLoading || downloadingShapeZip"
        />
      </b-form-group>
      
      <b-form-group label="Type (Optional)">
        <b-form-select
          v-model="type"
          :options="typeOptions"
          :disabled="downloadingShapeZip"
        />
      </b-form-group>
      <small class="text-muted">
        Leave empty to generate using default schema behavior.
      </small>
    </b-modal>

    <b-modal
      v-model="showGeodesiaSheetImportModal"
      title="استيراد جدول Geodesia / Trimble (Excel)"
      size="xl"
      scrollable
      hide-footer
      @hidden="resetGeodesiaSheetImport"
    >
      <!-- <p class="text-muted small mb-2">
        ملف Excel بتنسيق تصدير Trimble Business Center (بيانات وصفية ومنطقة UTM وجدول نقاط).
        سيتم ربط الاستيراد بالمشروع الحالي (معرف {{ projectId }}).
      </p> -->
      <b-form-group label="اختر ملف Excel">
        <b-form-file
          v-model="geodesiaSheetFile"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          placeholder="اختر ملف .xlsx أو .xls"
          drop-placeholder="اسحب الملف هنا"
          :disabled="importingGeodesiaSheet"
          @input="onGeodesiaSheetFileInput"
        />
        <small class="text-muted">الصيغ المدعومة: .xlsx و .xls فقط</small>
      </b-form-group>

      <div
        v-if="importingGeodesiaSheet"
        class="text-center my-3"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted mb-0">
          جاري رفع الملف ومعالجته...
        </p>
      </div>

      <b-alert
        v-if="geodesiaSheetImportError"
        variant="danger"
        show
        class="mt-2 mb-0"
      >
        {{ geodesiaSheetImportError }}
      </b-alert>

      <div
        v-if="geodesiaSheetImportResult"
        class="mt-3"
      >
        <b-alert
          :variant="Number(geodesiaSheetImportResult.errors_count || 0) > 0 ? 'warning' : 'success'"
          show
        >
          <p class="mb-1">
            <strong>اسم الملف:</strong> {{ geodesiaSheetImportResult.file_name }}
          </p>
          <p
            v-if="geodesiaSheetImportResult.file_updated"
            class="mb-1 text-info small"
          >
            تم استبدال ملف سابق بنفس الاسم.
          </p>
          <p class="mb-1">
            <strong>مقروءة:</strong> {{ geodesiaSheetImportResult.parsed_points_count }}
            — <strong>محفوظة:</strong> {{ geodesiaSheetImportResult.stored_points_count }}
            <span v-if="Number(geodesiaSheetImportResult.errors_count || 0) > 0">
              — <strong>أخطاء:</strong> {{ geodesiaSheetImportResult.errors_count }}
            </span>
          </p>
          <p
            v-if="geodesiaSheetImportResult.geodesia_sheet_file_id != null"
            class="mb-0 small"
          >
            <strong>معرف السجل:</strong> {{ geodesiaSheetImportResult.geodesia_sheet_file_id }}
            <span v-if="geodesiaSheetImportResult.media_id != null"> | <strong>media:</strong> {{ geodesiaSheetImportResult.media_id }}</span>
          </p>
        </b-alert>

        <div
          v-if="geodesiaSheetImportResult.errors && geodesiaSheetImportResult.errors.length"
          class="mt-2"
        >
          <h6 class="text-warning mb-1">
            أخطاء النقاط (لا تُخفى النقاط الناجحة)
          </h6>
          <ul class="small pl-3 mb-0">
            <li
              v-for="(rowErr, idx) in geodesiaSheetImportResult.errors"
              :key="'sheet-err-' + idx"
            >
              {{ formatGeodesiaSheetPointError(rowErr) }}
            </li>
          </ul>
        </div>

        <h6 class="mt-3 mb-1">
          النقاط المحفوظة
        </h6>
        <div
          v-if="geodesiaSheetTableRows.length"
          class="geodesia-sheet-import-table-wrap border rounded"
        >
          <b-table
            :items="geodesiaSheetTableRows"
            :fields="geodesiaSheetTableFields"
            small
            striped
            hover
            responsive
            class="mb-0"
          />
        </div>
        <p
          v-else
          class="text-muted small"
        >
          لا توجد صفوف إحداثيات في الاستجابة (قد يكون الاستيراد بدون إرجاع جدول تفصيلي).
        </p>
        <p class="text-muted small mt-2 mb-0">
          تم عرض النقاط ذات خط العرض/الطول الصالح على خريطة المسح أدناه.
        </p>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="importingGeodesiaSheet"
          @click="showGeodesiaSheetImportModal = false"
        >
          إغلاق
        </b-button>
        <b-button
          variant="primary"
          :disabled="!geodesiaSheetFile || importingGeodesiaSheet"
          @click="submitGeodesiaSheetImport"
        >
          <b-spinner
            v-if="importingGeodesiaSheet"
            small
            class="mr-50"
          />
          استيراد
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="showAddLocationModal"
      :title="editLocationId ? 'تعديل القطعة' : 'إضافة موقع جديد'"
      hide-footer
      centered
      @hidden="resetAddLocationForm"
    >
      <b-form @submit.prevent="submitLocationForm">
        <b-row>
          <b-col sm="12" md="6">

              <b-form-group label="رقم القطعة *" label-for="land-number-input">
              <b-form-input
                id="land-number-input"
                v-model.trim="addLocationForm.land_number"
                placeholder="ادخل رقم القطعة"
                :disabled="addingLocation"
                required
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">

        <b-form-group label="رقم البلوك" label-for="block-number-input">
          <b-form-input
            id="block-number-input"
            v-model.trim="addLocationForm.block_number"
            placeholder="ادخل رقم البلوك (اختياري)"
            :disabled="addingLocation"
          />
        </b-form-group>
        </b-col>
        <b-col sm="12" md="6">

        <b-form-group label="المساحة" label-for="location-area-input">
          <b-form-input
            id="location-area-input"
            v-model.number="addLocationForm.area"
            type="number"
            min="0"
            step="0.01"
            placeholder="ادخل المساحة (اختياري)"
            :disabled="addingLocation"
          />
        </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
        <b-form-group
          label="النشاط"
          label-for="natural-survey-location-activity"
        >
          <b-form-radio-group
            id="natural-survey-location-activity"
            v-model="addLocationForm.activity"
            :options="activityOptions"
            name="natural_survey_activity"
            stacked
            :disabled="addingLocation"
          />
        </b-form-group>
        </b-col>
        <b-col sm="12" md="6">

        <b-form-group
          label="الوضع"
          label-for="natural-survey-location-situation"
        >
          <b-form-radio-group
            id="natural-survey-location-situation"
            v-model="addLocationForm.situation"
            :options="situationOptions"
            name="natural_survey_situation"
            stacked
            :disabled="addingLocation"
          />
        </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
        <b-form-group
          label="الترميز"
          label-for="natural-survey-location-code"
        >
          <b-form-input
            id="natural-survey-location-code"
            v-model.trim="addLocationForm.code"
            :disabled="addingLocation"
          />
        </b-form-group>
        </b-col>
        <b-col sm="12" md="12">
        <b-form-group label="ملاحظات القطعة" label-for="location-notes-input">
          <b-form-textarea
            id="location-notes-input"
            v-model.trim="addLocationForm.location_notes"
            rows="3"
            max-rows="5"
            placeholder="ادخل ملاحظات (اختياري)"
            :disabled="addingLocation"
          />
        </b-form-group>
      </b-col>
        </b-row>
        
        <div class="d-flex justify-content-end">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            :disabled="addingLocation"
            @click="showAddLocationModal = false"
          >
            إلغاء
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            :disabled="addingLocation || !addLocationForm.land_number"
          >
            <b-spinner v-if="addingLocation" small class="mr-50" />
            {{ editLocationId ? 'حفظ التعديلات' : 'حفظ القطعة' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { loadArcgisModules, destroyArcgisView } from '@/utils/arcgisLoader'
import {
  buildSnappingOptions,
  buildSketchTooltipOptions,
  buildSketchValueOptions,
  buildSketchVisibleElements,
} from '@/views/modules/projects/arcgis/sketchOptions'
import MapLibrary from '@/api/MapLibrary/MapLibraries'
import geodesiaApi from '@/api/geodesia/geodesia'
import Projects from '@/api/projects/projects'
import projectShapeSchemasApi from '@/api/settings/projectShapeSchemas'
import {
  DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
  ADMINISTRATIVE_BOUNDARY_TYPES,
  administrativeBoundaryLayerKey,
  administrativeBoundaryLayerId,
  createAdministrativeBoundaryVisibility,
  fetchAdministrativeBoundariesGeoJson,
  isAdministrativeBoundaryLayerKey,
  mapAdministrativeBoundaryItemsToGraphics,
  normalizeAdministrativeBoundaryItems,
  typeFromAdministrativeBoundaryLayerKey,
} from '@/utils/administrativeBoundaries'
import { getSurveyPointArcgisSymbol } from '@/utils/surveyPointColors'
import {
  GEODESIA_LAYER_ERROR_MESSAGE,
  GEODESIA_LAYER_SOURCE,
  GEODESIA_LAYER_TRUNCATED_MESSAGE,
  GEODESIA_MAP_LAYER_KEYS,
  createGeodesiaLayerCancelSource,
  geodesiaLayerErrorMessage,
  getGeodesiaLayerFeatures,
  hexColorToRgb,
  isGeodesiaLayerRequestCanceled,
  isGeodesiaLayerTruncated,
  unwrapGeodesiaLayerPayload,
} from '@/utils/geodesiaMapLayers'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BAlert,
  BButton,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckbox,
  BFormSelect,
  BSpinner,
  BModal,
  BFormTextarea,
  BRow,
  BCol,
  BTable,
  VBTooltip,
} from 'bootstrap-vue'

const mapLibraryApi = new MapLibrary()

const DXF_GEOMETRY_OPTIONS = [
  { value: 'points', label: 'نقاط' },
  { value: 'polygons', label: 'مضلعات' },
  { value: 'lines', label: 'خطوط' },
]

const DXF_LAYER_OPTIONS = [
  { value: 'jxl', label: 'JXL' },
  { value: 'raw', label: 'RAW' },
  { value: 'rw5', label: 'RW5' },
  { value: 'kml', label: 'KML' },
  { value: 'kmz', label: 'KMZ' },
  { value: 'geodesia_sheet', label: 'Geodesia Sheet' },
]

const DXF_LAYER_LABELS = DXF_LAYER_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label
  return acc
}, {})

function createDxfExportCheckedState(options) {
  return options.reduce((acc, opt) => {
    acc[opt.value] = false
    return acc
  }, {})
}

export default {
  name: 'naturalSurveyMap',
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    project: {
      type: Object,
      default: null,
    },
  },
  components: {
    BAlert,
    BButton,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckbox,
    BFormSelect,
    BSpinner,
    BModal,
    BFormTextarea,
    BRow,
    BCol,
    BTable,
    ToastificationContent,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      homeButton: null,
      locationLoading: false,
      showSurveyMap: true,
      loadingLocations: false,
      loadingMapData: false,
      importingMapFiles: false,
      importingGeodesiaSurveyFile: false,
      geodesiaImportingType: null,
      showGeodesiaSheetImportModal: false,
      geodesiaSheetFile: null,
      importingGeodesiaSheet: false,
      geodesiaSheetImportError: null,
      geodesiaSheetImportResult: null,
      geodesiaSheetTableFields: [
        { key: 'point_name', label: 'النقطة' },
        { key: 'latitude', label: 'خط العرض' },
        { key: 'longitude', label: 'خط الطول' },
        { key: 'elevation', label: 'المنسوب (م)' },
        { key: 'utm_east', label: 'شرق UTM (م)' },
        { key: 'utm_north', label: 'شمال UTM (م)' },
        { key: 'utm_zone', label: 'منطقة UTM' },
      ],
      previewingProjectSurveyFileType: null,
      savingCoordinates: false,
      downloadingJxl: false,
      downloadingShapeZip: false,
      downloadingGeodesiaSheetShapeZip: false,
      showDxfExportModal: false,
      exportingDxf: false,
      dxfExportValidationError: null,
      dxfGeometryOptions: DXF_GEOMETRY_OPTIONS,
      dxfLayerOptions: DXF_LAYER_OPTIONS,
      dxfExportGeometryChecked: createDxfExportCheckedState(DXF_GEOMETRY_OPTIONS),
      dxfExportSourceLayersChecked: createDxfExportCheckedState(DXF_LAYER_OPTIONS),
      dxfExportGeometrySelectAll: false,
      dxfExportLayersSelectAll: false,
      dxfExportIncludeCartouche: true,
      showGeodesiaSheetShapeModal: false,
      geodesiaSheetShapeType: 'utm',
      geodesiaSheetShapeTypeOptions: [
        { text: 'UTM', value: 'utm' },
        { text: 'latLong', value: 'latLong' },
      ],
      showShapeSchemaModal: false,
      shapeSchemasLoading: false,
      shapeSchemas: [],
      type:null,
      typeOptions: [
        { text: 'UTM', value: 'UTM' },
        { text: 'latLong', value: 'latLong' },
      ],
      selectedShapeSchemaId: null,
      projectsApi: new Projects(),
      mapInitPromise: null,
      visibilityCheckInterval: null,
      selectedLocationId: null,
      pendingPolygonCoordinates: [],
      showAddLocationModal: false,
      editLocationId: null,
      addingLocation: false,
      deletingLocation: false,
      addLocationForm: {
        land_number: '',
        block_number: '',
        area: null,
        activity: null,
        situation: null,
        code: '',
        location_notes: '',
      },
      activityOptions: [
        { text: 'مبني', value: 'مبني' },
        { text: 'أرض', value: 'أرض' },
      ],
      situationOptions: [
        { text: 'مطلوب التقنيين', value: 'مطلوب التقنيين' },
        { text: 'اشغالات', value: 'اشغالات' },
        { text: 'ملكية خاصة', value: 'ملكية خاصة' },
      ],
      currentCoordinates: {
        lat: 31.2001,
        lng: 29.9187,
      },
      administrativeBoundariesYear: DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
      layerVisibility: {
        projects: true,
        mapLibraries: false,
        fixedPoints: false,
        ...createAdministrativeBoundaryVisibility(false),
        vrsCoordinates: false,
        jxlCoordinates: true,
        jxlRw5Coordinates: false,
        jxlRawCoordinates: false,
        jxlPolygons: false,
        jxlBaselineLines: false,
        userLocation: true,
      },
      geodesiaLayerCancels: {},
      geodesiaLayerLoaded: {},
      geodesiaLayerLoading: {},
      administrativeBoundarySketchReady: false,
    }
  },
  computed: {
    canViewAdministrativeBoundaries() {
      try {
        return typeof this.hasPermission === 'function'
          && this.hasPermission('view administrative_boundaries')
      } catch (e) {
        return false
      }
    },
    ...mapGetters({
      locationsData: 'projects/locationsData',
      loadExportKml: 'projects/loadExportKml',
      loadExportExcel: 'projects/loadExportExcel',
    }),
    locations() {
      return this.locationsData?.project_locations || []
    },
    locationOptions() {
      return this.locations.map(location => ({
        value: location.id,
        text: `قطعة ${location.land_number || location.id}`,
      }))
    },
    selectedLocation() {
      return this.locations.find(location => Number(location.id) === Number(this.selectedLocationId)) || null
    },
    geodesiaSheetTableRows() {
      const rows = this.geodesiaSheetImportResult?.coordinates
      if (!Array.isArray(rows)) return []
      return rows.map(row => ({
        point_name: row.point_name != null ? String(row.point_name) : (row.id != null ? String(row.id) : ''),
        latitude: row.latitude,
        longitude: row.longitude,
        elevation: row.elevation,
        utm_east: row.utm_east,
        utm_north: row.utm_north,
        utm_zone: row.utm_zone != null ? String(row.utm_zone) : '',
      }))
    },
    showJxlDownload() {
      const id = this.selectedLocationId
      return id !== null && id !== undefined && id !== ''
    },
    canDownloadGeodesiaSheetShape() {
      return !!(this.project && this.project.has_geodesia_sheet)
    },
    jxlFilenameFromSurveyingCode() {
      const raw = this.selectedLocation?.surveying_code
        || this.selectedLocation?.survey_coding
        || this.selectedLocation?.code
      if (raw === '' || raw === null || raw === undefined || String(raw).trim() === '') return ''
      const base = String(raw).trim().replace(/[\\/:*?"<>|]/g, '_')
      if (!base) return ''
      return /\.jxl$/i.test(base) ? base : `${base}.jxl`
    },
    shapeSchemaOptions() {
      const options = [{ value: null, text: 'Default (no schema selected)' }]
      this.shapeSchemas.forEach(schema => {
        options.push({
          value: schema.id,
          text: schema.name,
        })
      })
      return options
    },
    dxfExportSelectedGeometryTypes() {
      return DXF_GEOMETRY_OPTIONS
        .filter(opt => this.dxfExportGeometryChecked[opt.value])
        .map(opt => opt.value)
    },
    dxfExportSelectedSourceLayers() {
      return DXF_LAYER_OPTIONS
        .filter(opt => this.dxfExportSourceLayersChecked[opt.value])
        .map(opt => opt.value)
    },
    canConfirmDxfExport() {
      return this.dxfExportSelectedGeometryTypes.length > 0
        && this.dxfExportSelectedSourceLayers.length > 0
    },
    dxfExportLocalStorageKey() {
      const userId = this.$store?.state?.users?.auth?.id
      return userId ? `project-dxf-export-prefs-${userId}` : 'project-dxf-export-prefs'
    },
  },
  watch: {},
  created() {
    // ArcGIS objects must stay off Vue's reactive data(): deep observation slows the map and breaks API methods.
    Object.assign(this, {
      view: null,
      map: null,
      sketch: null,
      drawLayer: null,
      existingPolygonsLayer: null,
      projectsLayer: null,
      mapLibrariesLayer: null,
      fixedPointsLayer: null,
      vrsCoordinatesLayer: null,
      jxlCoordinatesLayer: null,
      jxlRw5CoordinatesLayer: null,
      jxlRawCoordinatesLayer: null,
      jxlPolygonsLayer: null,
      jxlBaselineLinesLayer: null,
      importedPointsLayer: null,
      userLocationLayer: null,
      arcgisModules: null,
      administrativeBoundaryLayers: {},
    })
  },
  methods: {
    async onMapCollapseShown() {
      this.loadingMapData = true
      try {
        await this.ensureMapReady()
        await this.loadSpatialData()
        try {
          await this.view.when()
        } catch (e) {
          // view may already be resolving
        }
        await this.$nextTick()
        if (this.selectedLocationId) {
          this.focusLocationOnMap(this.selectedLocationId)
        } else {
          this.fitMapToSpatialProjectData()
        }
        await this.loadMapAllData()
        await this.loadVisibleGeodesiaLayers()
      } catch (error) {
        console.error('Failed to open natural survey map:', error)
        this.$toast?.error?.('تعذر تحميل الخريطة حالياً')
      } finally {
        this.loadingMapData = false
      }
    },
    async setCurrentToGeolocation() {
      if (!navigator.geolocation) return
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            resolve,
            reject,
            {
              enableHighAccuracy: true,
              timeout: 10000,
            },
          )
        })
        this.currentCoordinates.lat = position.coords.latitude
        this.currentCoordinates.lng = position.coords.longitude
      } catch (error) {
        // Keep fallback coordinates
      }
    },
    parseDownloadFilename(contentDisposition, fallbackName) {
      if (!contentDisposition || typeof contentDisposition !== 'string') return fallbackName

      const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]).replace(/["']/g, '')
        } catch (e) {
          return utf8Match[1].replace(/["']/g, '')
        }
      }

      const simpleMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
      if (simpleMatch && simpleMatch[1]) {
        return simpleMatch[1].trim()
      }

      return fallbackName
    },
    jxlErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_coordinates_for_jxl: 'لا توجد إحداثيات للتصدير (مكتب فني أو حقول).',
        jxl_export_failed: detail || 'فشل إنشاء ملف JXL.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تحميل ملف JXL'
    },
    shapeZipErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_coordinates_for_shape_export: 'لا توجد إحداثيات متاحة لتصدير ملف Shape ZIP.',
        shape_export_failed: detail || 'فشل إنشاء ملف Shape ZIP.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تنزيل ملف Shape ZIP'
    },
    geodesiaSheetShapeZipErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        project_does_not_have_geodesia_sheet_file: 'المشروع لا يحتوي على شيت جيوديسيا',
        no_coordinates_for_shape_export: 'لا توجد إحداثيات صالحة في شيت الجيوديسيا',
        shape_export_failed: detail || 'فشل تصدير ملف الشيب',
        failed_to_create_zip: detail || 'فشل تصدير ملف الشيب',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'فشل تصدير ملف الشيب'
    },
    async parseErrorResponseData(data) {
      if (data instanceof Blob) {
        const text = await data.text()
        try {
          return JSON.parse(text)
        } catch (e) {
          return { message: text }
        }
      }
      return data || {}
    },
    triggerBlobDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    async isJsonBlob(blob) {
      if (!(blob instanceof Blob)) return false
      const contentType = String(blob.type || '').toLowerCase()
      if (contentType.includes('application/json') || contentType.includes('text/json')) return true
      try {
        const text = (await blob.text()).trim()
        return text.startsWith('{') || text.startsWith('[')
      } catch (e) {
        return false
      }
    },
    sanitizeFilePart(value) {
      return String(value || '')
        .trim()
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '')
        .replace(/\s+/g, '_')
    },
    getExcelFallbackFilename() {
      const ownerNameRaw = this.project?.owners?.[0]?.name || 'owner'
      const surveyingCodeRaw = this.project?.surveying_code || `project-${this.projectId}`
      const ownerName = this.sanitizeFilePart(ownerNameRaw) || 'owner'
      const surveyingCode = this.sanitizeFilePart(surveyingCodeRaw) || `project-${this.projectId}`
      return `${ownerName}_${surveyingCode}.xlsx`
    },
    exportExcel(projectLocationId) {
      if (!this.projectId || !projectLocationId) return

      this.$store.dispatch('projects/exportExcel', { projectLocationId })
        .then(response => {
          const responseData = response?.data ?? response
          const blob = responseData instanceof Blob
            ? responseData
            : new Blob([responseData], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          const contentDisposition = response?.headers?.['content-disposition'] || ''
          const filename = this.parseDownloadFilename(contentDisposition, this.getExcelFallbackFilename())
          this.triggerBlobDownload(blob, filename)
        })
        .catch(error => {
          const status = error?.response?.status
          let message = 'Failed to export Excel file'
          if (status === 403) message = "You don't have permission to export this project"
          else if (status === 404) message = 'Project not found'

          this.$swal({
            icon: 'error',
            title: message,
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        })
    },
    exportKml(locationId) {
      if (!locationId) return

      this.$store.dispatch('projects/exportKml', { id: locationId })
        .then(response => {
          const blob = response instanceof Blob
            ? response
            : new Blob([response], { type: 'application/vnd.google-earth.kml+xml' })
          this.triggerBlobDownload(blob, `location_${locationId}.kml`)
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: error.response?.data?.message || 'تعذر تحميل الملف',
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        })
    },
    async downloadCoordinatesJxl() {
      const id = this.selectedLocationId
      if (id === null || id === undefined || id === '') return

      this.downloadingJxl = true
      try {
        const response = await this.projectsApi.exportCoordinatesJxl(id)
        const contentType = String(response.headers['content-type'] || '').toLowerCase()
        let { data: blob } = response

        if (contentType.includes('application/json')) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.jxlErrorMessage(payload)), { payload })
        }

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/xml' })
        }

        const cd = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(cd, '') || '').trim()
        const filename = this.jxlFilenameFromSurveyingCode
          || fromHeader
          || `location-${id}.jxl`
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف JXL')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.jxlErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingJxl = false
      }
    },
    async loadShapeSchemasForExport() {
      this.shapeSchemasLoading = true
      try {
        const response = await projectShapeSchemasApi.list()
        this.shapeSchemas = Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : [])
      } catch (error) {
        this.shapeSchemas = []
      } finally {
        this.shapeSchemasLoading = false
      }
    },
    openShapeSchemaModal() {
      this.type = null
      this.selectedShapeSchemaId = null
      this.showShapeSchemaModal = true
    },
    confirmShapeZipDownload(event) {
      event.preventDefault()
      this.showShapeSchemaModal = false
      this.downloadShapeZip(this.selectedShapeSchemaId, this.type)
    },
    resetDxfExportCheckboxState() {
      this.dxfExportGeometryChecked = createDxfExportCheckedState(DXF_GEOMETRY_OPTIONS)
      this.dxfExportSourceLayersChecked = createDxfExportCheckedState(DXF_LAYER_OPTIONS)
      this.dxfExportGeometrySelectAll = false
      this.dxfExportLayersSelectAll = false
      this.dxfExportIncludeCartouche = true
    },
    resetDxfExportValidation() {
      this.dxfExportValidationError = null
    },
    loadDxfExportPrefsFromStorage() {
      try {
        const raw = localStorage.getItem(this.dxfExportLocalStorageKey)
        if (!raw) return
        const prefs = JSON.parse(raw)
        if (prefs.geometry && typeof prefs.geometry === 'object') {
          DXF_GEOMETRY_OPTIONS.forEach(opt => {
            if (Object.prototype.hasOwnProperty.call(prefs.geometry, opt.value)) {
              this.$set(this.dxfExportGeometryChecked, opt.value, !!prefs.geometry[opt.value])
            }
          })
        }
        if (prefs.layers && typeof prefs.layers === 'object') {
          DXF_LAYER_OPTIONS.forEach(opt => {
            if (Object.prototype.hasOwnProperty.call(prefs.layers, opt.value)) {
              this.$set(this.dxfExportSourceLayersChecked, opt.value, !!prefs.layers[opt.value])
            }
          })
        }
        if (typeof prefs.include_cartouche === 'boolean') {
          this.dxfExportIncludeCartouche = prefs.include_cartouche
        }
        this.syncDxfExportGeometrySelectAll()
        this.syncDxfExportLayersSelectAll()
      } catch (e) {
        // ignore corrupt prefs
      }
    },
    saveDxfExportPrefsToStorage() {
      try {
        const prefs = {
          geometry: { ...this.dxfExportGeometryChecked },
          layers: { ...this.dxfExportSourceLayersChecked },
          include_cartouche: this.dxfExportIncludeCartouche,
        }
        localStorage.setItem(this.dxfExportLocalStorageKey, JSON.stringify(prefs))
      } catch (e) {
        // ignore quota errors
      }
    },
    openDxfExportModal() {
      this.resetDxfExportCheckboxState()
      this.resetDxfExportValidation()
      this.loadDxfExportPrefsFromStorage()
      this.showDxfExportModal = true
    },
    onDxfExportGeometrySelectAllChange(checked) {
      DXF_GEOMETRY_OPTIONS.forEach(opt => {
        this.$set(this.dxfExportGeometryChecked, opt.value, !!checked)
      })
      this.dxfExportValidationError = null
    },
    onDxfExportLayersSelectAllChange(checked) {
      DXF_LAYER_OPTIONS.forEach(opt => {
        this.$set(this.dxfExportSourceLayersChecked, opt.value, !!checked)
      })
      this.dxfExportValidationError = null
    },
    syncDxfExportGeometrySelectAll() {
      this.dxfExportGeometrySelectAll = DXF_GEOMETRY_OPTIONS.every(
        opt => this.dxfExportGeometryChecked[opt.value],
      )
      this.dxfExportValidationError = null
    },
    syncDxfExportLayersSelectAll() {
      this.dxfExportLayersSelectAll = DXF_LAYER_OPTIONS.every(
        opt => this.dxfExportSourceLayersChecked[opt.value],
      )
      this.dxfExportValidationError = null
    },
    buildDxfExportPayload() {
      return {
        geometry_types: this.dxfExportSelectedGeometryTypes,
        source_layers: this.dxfExportSelectedSourceLayers,
        include_cartouche: !!this.dxfExportIncludeCartouche,
      }
    },
    dxfExportErrorMessage(payload) {
      const key = payload?.message
      const errors = payload?.errors && typeof payload.errors === 'object' ? payload.errors : {}
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : Object.values(errors).flat().filter(Boolean).join(' ')

      if (key === 'project_missing_selected_files' && Array.isArray(errors.missing_source_layers)) {
        const labels = errors.missing_source_layers
          .map(layer => DXF_LAYER_LABELS[layer] || layer)
          .join('، ')
        return `المشروع لا يحتوي على: ${labels}`
      }

      const map = {
        no_survey_files_at_all: 'المشروع لا يحتوي على ملفات مسح',
        no_exportable_coordinates: 'لا توجد إحداثيات قابلة للتصدير في الاختيار الحالي',
        project_missing_selected_files: detail || 'المشروع لا يحتوي على الملفات المحددة',
      }

      if (errors.geometry_types?.length) {
        return errors.geometry_types.join(' ')
      }
      if (errors.source_layers?.length) {
        return errors.source_layers.join(' ')
      }

      if (key && map[key]) return map[key]
      if (typeof payload?.message === 'string' && payload.message && payload.success === false) {
        return payload.message
      }
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تصدير ملف DXF'
    },
    async confirmDxfExport() {
      if (this.exportingDxf) return

      if (this.dxfExportSelectedGeometryTypes.length === 0) {
        this.dxfExportValidationError = 'يجب اختيار نوع هندسة واحد على الأقل'
        return
      }
      if (this.dxfExportSelectedSourceLayers.length === 0) {
        this.dxfExportValidationError = 'يجب اختيار مصدر ملف واحد على الأقل'
        return
      }

      this.dxfExportValidationError = null
      const projectId = Number(this.projectId)
      if (!Number.isFinite(projectId) || projectId <= 0) return

      const payload = this.buildDxfExportPayload()
      this.exportingDxf = true
      try {
        const response = await this.projectsApi.exportProjectDxf(projectId, payload)
        const status = response.status
        let { data: blob } = response

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob])
        }

        const maybeJson = status >= 400 || await this.isJsonBlob(blob)
        if (maybeJson) {
          const errorPayload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.dxfExportErrorMessage(errorPayload)), { payload: errorPayload })
        }

        if (String(blob.type || '').toLowerCase() !== 'application/dxf') {
          blob = new Blob([blob], { type: 'application/dxf' })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const surveyingCode = this.sanitizeFilePart(this.project?.surveying_code)
        const filename = fromHeader
          || (surveyingCode ? `${surveyingCode}.dxf` : `project_${projectId}.dxf`)
        this.triggerBlobDownload(blob, filename)
        this.saveDxfExportPrefsToStorage()
        this.showDxfExportModal = false
        this.$toast?.success?.('تم تنزيل ملف DXF')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.dxfExportErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.exportingDxf = false
      }
    },
    openGeodesiaSheetShapeModal() {
      this.geodesiaSheetShapeType = 'utm'
      this.showGeodesiaSheetShapeModal = true
    },
    confirmGeodesiaSheetShapeDownload(event) {
      event.preventDefault()
      this.showGeodesiaSheetShapeModal = false
      this.downloadGeodesiaSheetShapeZip(this.geodesiaSheetShapeType)
    },
    async downloadGeodesiaSheetShapeZip(type = 'utm') {
      const projectId = Number(this.projectId)
      if (!Number.isFinite(projectId) || projectId <= 0) return

      this.downloadingGeodesiaSheetShapeZip = true
      try {
        const response = await this.projectsApi.downloadProjectGeodesiaSheetShapeZip(projectId, type)
        let { data: blob } = response
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        const maybeJson = await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.geodesiaSheetShapeZipErrorMessage(payload)), { payload })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const surveyingCode = this.sanitizeFilePart(this.project?.surveying_code)
        const filename = fromHeader
          || (surveyingCode
            ? `${surveyingCode}_geodesia_sheet_shapefile.zip`
            : `project-${projectId}_geodesia_sheet_shapefile.zip`)
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل شيب جيوديسيا')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.geodesiaSheetShapeZipErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingGeodesiaSheetShapeZip = false
      }
    },
    async downloadShapeZip(schemaId = null, type = null) {
      const projectId = Number(this.projectId)
      if (!Number.isFinite(projectId) || projectId <= 0) return

      this.downloadingShapeZip = true
      try {
        const response = await this.projectsApi.downloadProjectShapeZipDivided(projectId, schemaId, type)
        let { data: blob } = response
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        const maybeJson = await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.shapeZipErrorMessage(payload)), { payload })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const filename = fromHeader || `project_${projectId}_shapefile.zip`
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('Shape ZIP downloaded successfully')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.shapeZipErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingShapeZip = false
      }
    },
    toggleLayer(layerName) {
      const layerMap = {
        projects: this.projectsLayer,
        mapLibraries: this.mapLibrariesLayer,
        fixedPoints: this.fixedPointsLayer,
        vrsCoordinates: this.vrsCoordinatesLayer,
        jxlCoordinates: this.jxlCoordinatesLayer,
        jxlRw5Coordinates: this.jxlRw5CoordinatesLayer,
        jxlRawCoordinates: this.jxlRawCoordinatesLayer,
        jxlPolygons: this.jxlPolygonsLayer,
        jxlBaselineLines: this.jxlBaselineLinesLayer,
        userLocation: this.userLocationLayer,
      }
      ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
        layerMap[administrativeBoundaryLayerKey(item.type)] = this.administrativeBoundaryLayers?.[item.type]
      })
      const layer = layerMap[layerName]
      if (layer) layer.visible = this.layerVisibility[layerName]
      if (
        isAdministrativeBoundaryLayerKey(layerName)
        && this.layerVisibility[layerName]
        && this.canViewAdministrativeBoundaries
      ) {
        const type = typeFromAdministrativeBoundaryLayerKey(layerName)
        const typeLayer = this.administrativeBoundaryLayers?.[type]
        if (typeLayer && typeLayer.graphics.length === 0) {
          this.loadAdministrativeBoundaryType(type)
        }
      }
      if (GEODESIA_MAP_LAYER_KEYS.includes(layerName)) {
        if (this.layerVisibility[layerName]) {
          this.loadGeodesiaMapLayer(layerName)
        } else {
          this.cancelGeodesiaLayerRequest(layerName)
        }
      }
      if (this.sketch?.viewModel?.snappingOptions?.featureSources) {
        this.sketch.viewModel.snappingOptions.featureSources.forEach(source => {
          if (!source.layer) return
          if (source.layer === layer) {
            source.enabled = this.layerVisibility[layerName]
          }
        })
      }
    },
    updateLayerVisibility() {
      if (this.projectsLayer) this.projectsLayer.visible = this.layerVisibility.projects
      if (this.mapLibrariesLayer) this.mapLibrariesLayer.visible = this.layerVisibility.mapLibraries
      if (this.fixedPointsLayer) this.fixedPointsLayer.visible = this.layerVisibility.fixedPoints
      ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
        const typeLayer = this.administrativeBoundaryLayers?.[item.type]
        if (typeLayer) {
          typeLayer.visible = this.canViewAdministrativeBoundaries
            && this.layerVisibility[administrativeBoundaryLayerKey(item.type)] === true
        }
      })
      if (this.vrsCoordinatesLayer) this.vrsCoordinatesLayer.visible = this.layerVisibility.vrsCoordinates
      if (this.jxlCoordinatesLayer) this.jxlCoordinatesLayer.visible = this.layerVisibility.jxlCoordinates
      if (this.jxlRw5CoordinatesLayer) this.jxlRw5CoordinatesLayer.visible = this.layerVisibility.jxlRw5Coordinates
      if (this.jxlRawCoordinatesLayer) this.jxlRawCoordinatesLayer.visible = this.layerVisibility.jxlRawCoordinates
      if (this.jxlPolygonsLayer) this.jxlPolygonsLayer.visible = this.layerVisibility.jxlPolygons
      if (this.jxlBaselineLinesLayer) this.jxlBaselineLinesLayer.visible = this.layerVisibility.jxlBaselineLines
      if (this.userLocationLayer) this.userLocationLayer.visible = this.layerVisibility.userLocation
    },
    async ensureMapReady() {
      if (!this.showSurveyMap) {
        this.showSurveyMap = true
        await this.$nextTick()
        await new Promise(resolve => {
          if (typeof window !== 'undefined' && window.requestAnimationFrame) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(resolve)
            })
          } else {
            resolve()
          }
        })
        await new Promise(r => setTimeout(r, 200))
      }

      if (this.view) {
        try {
          await this.view.when()
          this.view.resize()
        } catch (e) {
          // view may still be initializing
        }
        return
      }

      if (this.mapInitPromise) {
        await this.mapInitPromise
        return
      }
      if (!this.$refs.mapContainer) {
        await this.$nextTick()
      }
      if (!this.$refs.mapContainer) {
        throw new Error('Map container is not ready yet')
      }

      this.mapInitPromise = (async () => {
        const moduleList = [
          'esri/Map',
          'esri/views/MapView',
          'esri/layers/GraphicsLayer',
          'esri/Graphic',
          'esri/geometry/Point',
          'esri/geometry/Polygon',
          'esri/geometry/Polyline',
          'esri/geometry/Extent',
          'esri/symbols/SimpleMarkerSymbol',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/widgets/Sketch',
          'esri/geometry/geometryEngine',
          'esri/geometry/support/webMercatorUtils',
        ]

        const loaded = await loadArcgisModules(moduleList)

        const [
          Map,
          MapView,
          GraphicsLayer,
          Graphic,
          Point,
          Polygon,
          Polyline,
          Extent,
          SimpleMarkerSymbol,
          SimpleFillSymbol,
          SimpleLineSymbol,
          Sketch,
          geometryEngine,
          webMercatorUtils,
        ] = loaded

        this.arcgisModules = {
          Map,
          MapView,
          GraphicsLayer,
          Graphic,
          Point,
          Polygon,
          Polyline,
          Extent,
          SimpleMarkerSymbol,
          SimpleFillSymbol,
          SimpleLineSymbol,
          Sketch,
          geometryEngine,
          webMercatorUtils,
        }

      // Same layer setup/order as GeodesiaLab.vue
      this.projectsLayer = new GraphicsLayer({ title: 'المشاريع', visible: this.layerVisibility.projects })
      this.mapLibrariesLayer = new GraphicsLayer({ title: 'مكتبات الخرائط', visible: this.layerVisibility.mapLibraries })
      this.fixedPointsLayer = new GraphicsLayer({ title: 'النقاط الثابتة', visible: this.layerVisibility.fixedPoints })
      const administrativeBoundaryLayers = {}
      ADMINISTRATIVE_BOUNDARY_TYPES.forEach(item => {
        const key = administrativeBoundaryLayerKey(item.type)
        administrativeBoundaryLayers[item.type] = new GraphicsLayer({
          id: administrativeBoundaryLayerId(item.type),
          title: item.title,
          listMode: 'show',
          visible: this.canViewAdministrativeBoundaries
            && this.layerVisibility[key] === true,
        })
      })
      this.administrativeBoundaryLayers = administrativeBoundaryLayers
      this.vrsCoordinatesLayer = new GraphicsLayer({ title: 'إحداثيات VRS', visible: this.layerVisibility.vrsCoordinates })
      this.jxlCoordinatesLayer = new GraphicsLayer({ title: 'إحداثيات JXL', visible: this.layerVisibility.jxlCoordinates })
      this.jxlRw5CoordinatesLayer = new GraphicsLayer({ title: 'إحداثيات RW5', visible: this.layerVisibility.jxlRw5Coordinates })
      this.jxlRawCoordinatesLayer = new GraphicsLayer({ title: 'إحداثيات RAW', visible: this.layerVisibility.jxlRawCoordinates })
      this.jxlPolygonsLayer = new GraphicsLayer({ title: 'مضلعات JXL', visible: this.layerVisibility.jxlPolygons })
      this.jxlBaselineLinesLayer = new GraphicsLayer({ title: 'خطوط الأساس (JXL)', visible: this.layerVisibility.jxlBaselineLines })
      this.importedPointsLayer = new GraphicsLayer({ title: 'Imported Points', visible: true })
      this.userLocationLayer = new GraphicsLayer({ title: 'موقعي الحالي', visible: this.layerVisibility.userLocation })
      this.existingPolygonsLayer = new GraphicsLayer({ title: 'Saved Polygons' })
      this.drawLayer = new GraphicsLayer({ title: 'Draw Layer' })

      this.map = new Map({
        basemap: 'hybrid',
        layers: [
          ...Object.values(administrativeBoundaryLayers),
          this.projectsLayer,
          this.mapLibrariesLayer,
          this.fixedPointsLayer,
          this.vrsCoordinatesLayer,
          this.jxlPolygonsLayer,
          this.jxlBaselineLinesLayer,
          this.jxlRawCoordinatesLayer,
          this.jxlRw5CoordinatesLayer,
          this.jxlCoordinatesLayer,
          this.importedPointsLayer,
          this.userLocationLayer,
          this.existingPolygonsLayer,
          this.drawLayer,
        ],
      })
      this.updateLayerVisibility()

      await this.setCurrentToGeolocation()
      this.view = new MapView({
        container: this.$refs.mapContainer,
        map: this.map,
        center: [this.currentCoordinates.lng, this.currentCoordinates.lat],
        zoom: 17,
      })

      this.sketch = new Sketch({
        view: this.view,
        layer: this.drawLayer,
        availableCreateTools: ['point', 'polyline', 'polygon', 'rectangle', 'circle'],
        visibleElements: buildSketchVisibleElements(),
        valueOptions: buildSketchValueOptions(),
        snappingOptions: buildSnappingOptions([
          { layer: this.userLocationLayer, enabled: this.layerVisibility.userLocation },
          { layer: this.projectsLayer, enabled: this.layerVisibility.projects },
          { layer: this.mapLibrariesLayer, enabled: this.layerVisibility.mapLibraries },
          { layer: this.fixedPointsLayer, enabled: this.layerVisibility.fixedPoints },
          ...(this.canViewAdministrativeBoundaries
            ? ADMINISTRATIVE_BOUNDARY_TYPES.map(item => ({
              layer: administrativeBoundaryLayers[item.type],
              enabled: this.layerVisibility[administrativeBoundaryLayerKey(item.type)] === true,
            }))
            : []),
          { layer: this.vrsCoordinatesLayer, enabled: this.layerVisibility.vrsCoordinates },
          { layer: this.jxlCoordinatesLayer, enabled: this.layerVisibility.jxlCoordinates },
          { layer: this.jxlRw5CoordinatesLayer, enabled: this.layerVisibility.jxlRw5Coordinates },
          { layer: this.jxlRawCoordinatesLayer, enabled: this.layerVisibility.jxlRawCoordinates },
          { layer: this.jxlPolygonsLayer, enabled: this.layerVisibility.jxlPolygons },
          { layer: this.jxlBaselineLinesLayer, enabled: this.layerVisibility.jxlBaselineLines },
          { layer: this.existingPolygonsLayer, enabled: true },
          { layer: this.drawLayer, enabled: true },
        ]),
        tooltipOptions: buildSketchTooltipOptions(),
      })
      this.view.ui.add(this.sketch, 'top-right')

      // Keep layer visibility synced with snapping source enable/disable state
      const layerMap = {
        [this.userLocationLayer.id]: this.userLocationLayer,
        [this.projectsLayer.id]: this.projectsLayer,
        [this.mapLibrariesLayer.id]: this.mapLibrariesLayer,
        [this.fixedPointsLayer.id]: this.fixedPointsLayer,
        ...Object.fromEntries(
          ADMINISTRATIVE_BOUNDARY_TYPES
            .map(item => administrativeBoundaryLayers[item.type])
            .filter(Boolean)
            .map(layer => [layer.id, layer]),
        ),
        [this.vrsCoordinatesLayer.id]: this.vrsCoordinatesLayer,
        [this.jxlCoordinatesLayer.id]: this.jxlCoordinatesLayer,
        [this.jxlRw5CoordinatesLayer.id]: this.jxlRw5CoordinatesLayer,
        [this.jxlRawCoordinatesLayer.id]: this.jxlRawCoordinatesLayer,
        [this.jxlPolygonsLayer.id]: this.jxlPolygonsLayer,
        [this.jxlBaselineLinesLayer.id]: this.jxlBaselineLinesLayer,
      }

      const syncLayerVisibility = () => {
        const { snappingOptions } = this.sketch.viewModel
        if (snappingOptions && snappingOptions.featureSources) {
          snappingOptions.featureSources.forEach(source => {
            if (!source.layer || !layerMap[source.layer.id]) return
            const type = ADMINISTRATIVE_BOUNDARY_TYPES.find(
              item => administrativeBoundaryLayers[item.type] === source.layer,
            )?.type
            if (type) {
              const enabled = this.canViewAdministrativeBoundaries
                && this.layerVisibility[administrativeBoundaryLayerKey(type)] === true
              if (!this.administrativeBoundarySketchReady || source.enabled !== enabled) {
                source.enabled = enabled
              }
              source.layer.visible = enabled
              return
            }
            layerMap[source.layer.id].visible = source.enabled !== false
          })
        }
      }
      this.addHomeButtonToView()
      // Watch source enabled changes
      const featureSources = this.sketch.viewModel.snappingOptions?.featureSources || []
      featureSources.forEach(source => {
        if (source.watch) {
          source.watch('enabled', enabled => {
            const type = ADMINISTRATIVE_BOUNDARY_TYPES.find(
              item => administrativeBoundaryLayers[item.type] === source.layer,
            )?.type
            if (type) {
              const key = administrativeBoundaryLayerKey(type)
              if (!this.administrativeBoundarySketchReady) {
                source.enabled = this.layerVisibility[key] === true
                if (source.layer) source.layer.visible = source.enabled && this.canViewAdministrativeBoundaries
                return
              }
              this.layerVisibility[key] = enabled === true
              if (source.layer) {
                source.layer.visible = enabled === true && this.canViewAdministrativeBoundaries
              }
              if (
                enabled
                && this.canViewAdministrativeBoundaries
                && source.layer?.graphics?.length === 0
              ) {
                this.loadAdministrativeBoundaryType(type)
              }
              return
            }
            syncLayerVisibility()
          })
        }
      })

      // Periodic safety sync (same idea as GeodesiaLab visibilityCheckInterval)
      this.visibilityCheckInterval = setInterval(() => {
        syncLayerVisibility()
      }, 500)

      this.administrativeBoundarySketchReady = false
      syncLayerVisibility()
      this.$nextTick(() => {
        syncLayerVisibility()
        window.setTimeout(() => {
          this.administrativeBoundarySketchReady = true
          syncLayerVisibility()
        }, 1000)
      })

        this.sketch.viewModel.on('create', event => {
          if (event.state !== 'complete') return
          if (event.graphic?.geometry?.type !== 'polygon') return

          this.capturePendingPolygonCoordinates(event.graphic.geometry)

          const area = geometryEngine.geodesicArea(event.graphic.geometry, 'square-meters')
          if (this.$toast) {
            this.$toast.success(`تم رسم مضلع جديد بمساحة ${Number(area || 0).toFixed(2)} م²`)
          }
        })

        this.sketch.viewModel.on('update', event => {
          const polygonGeometry = event?.graphics?.[0]?.geometry
          if (polygonGeometry?.type !== 'polygon') return

          const toolEventType = event?.toolEventInfo?.type || ''
          const shouldCaptureDuringActive = event.state === 'active' && /-stop$/.test(toolEventType)
          const shouldCaptureOnComplete = event.state === 'complete'
          if (!shouldCaptureDuringActive && !shouldCaptureOnComplete) return

          this.capturePendingPolygonCoordinates(polygonGeometry)
        })
      })()
      try {
        await this.mapInitPromise
      } finally {
        this.mapInitPromise = null
      }
    },
    addHomeButtonToView() {
      if (!this.view) return

      const button = document.createElement('button')
      button.className = 'esri-widget--button esri-widget home-location-button'
      button.title = 'الذهاب إلى موقعي الحالي'

      button.addEventListener('click', () => {
        this.addUserLocation()
      })

      // Keep reference so we can show loader state
      this.homeButton = button
      this.setHomeButtonLoading(this.locationLoading)

      // Place it with the zoom controls (top-left)
      this.view.ui.add(button, 'top-left')
    },
    async addUserLocation() {
      if (this.locationLoading) return
      this.locationLoading = true
      this.setHomeButtonLoading(true)

      try {
        const location = await this.getUserCurrentLocation()

        if (!this.userLocationLayer || !this.arcgisModules) return

        const { Point, Graphic, SimpleMarkerSymbol } = this.arcgisModules

        // Clear existing user location
        this.userLocationLayer.removeAll()

        // Create point geometry
        const point = new Point({
          longitude: location.longitude,
          latitude: location.latitude,
          spatialReference: { wkid: 4326 },
        })

        // Create symbol - blue point for current location
        const symbol = new SimpleMarkerSymbol({
          style: 'circle',
          color: [0, 0, 255], // Blue
          size: 12,
          outline: {
            color: [255, 255, 255],
            width: 2,
          },
        })

        // Create graphic
        const graphic = new Graphic({
          geometry: point,
          symbol,
          attributes: {
            id: 'user_location',
            name: 'موقعي الحالي',
          },
          popupTemplate: {
            title: 'موقعي الحالي',
            content: `
              <b>خط العرض:</b> ${location.latitude.toFixed(6)}<br>
              <b>خط الطول:</b> ${location.longitude.toFixed(6)}<br>
              <b>الدقة:</b> ${location.accuracy ? location.accuracy.toFixed(2) : 'N/A'} متر
            `,
          },
        })

        this.userLocationLayer.add(graphic)

        // Center map on user location
        if (this.view) {
          try {
            // Ensure view is ready
            await this.view.when()
            await this.view.goTo({
              center: [location.longitude, location.latitude],
              zoom: 15,
            }, {
              animate: false, // Disable animation to avoid animation errors
            })
          } catch (err) {
            console.warn('Error navigating to user location:', err)
            // Fallback: set center directly without animation
            try {
              this.view.center = [location.longitude, location.latitude]
              this.view.zoom = 15
            } catch (fallbackErr) {
              console.error('Error setting view center directly:', fallbackErr)
            }
          }
        }
      } catch (error) {
        console.error('Error getting user location:', error)
        if (this.$toast && this.$toast.error) {
          this.$toast.error('فشل في الحصول على موقعك')
        }
      } finally {
        this.locationLoading = false
        this.setHomeButtonLoading(false)
      }
    },
    setHomeButtonLoading(isLoading) {
      if (!this.homeButton) return

      if (isLoading) {
        this.homeButton.classList.add('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="home-location-spinner"></span>'
      } else {
        this.homeButton.classList.remove('home-location-button--loading')
        this.homeButton.innerHTML = '<span class="home-location-button__icon" aria-hidden="true">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" '
          + 'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
          + '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>'
          + '<polyline points="9 22 9 12 15 12 15 22"/>'
          + '</svg></span>'
      }
    },
    getUserCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation is not supported by your browser'))
          return
        }

        navigator.geolocation.getCurrentPosition(
          position => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
            })
          },
          error => {
            reject(error)
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          },
        )
      })
    },
    convertToDMS(rings) {
      const { webMercatorUtils } = this.arcgisModules || {}
      if (!webMercatorUtils || typeof webMercatorUtils.xyToLngLat !== 'function') {
        console.warn('webMercatorUtils not available; returning original coordinates.')
        return rings
      }

      return rings.map(ring => ring.map(coord => {
        if (Array.isArray(coord) && coord.length >= 2) {
          const [longitude, latitude] = webMercatorUtils.xyToLngLat(coord[0], coord[1])
          return [longitude, latitude]
        }
        return coord
      }))
    },
    capturePendingPolygonCoordinates(polygonGeometry) {
      if (!polygonGeometry || polygonGeometry.type !== 'polygon') return
      const rings = polygonGeometry.rings?.[0] || []
      const convertedRings = this.convertToDMS([rings])
      const normalizedRing = Array.isArray(convertedRings?.[0]) ? convertedRings[0] : rings
      this.pendingPolygonCoordinates = normalizedRing.map(point => ({
        latitude: Number(point[1]),
        longitude: Number(point[0]),
        type: 'fields',
        x: Number(point[0]),
        y: Number(point[1]),
      }))
    },
    getGeodesiaFileInputRef(type) {
      const inputRefs = {
        jxl: 'geodesiaJxlFileInput',
        rw5: 'geodesiaRw5FileInput',
        raw: 'geodesiaRawFileInput',
        kmz: 'geodesiaKmzFileInput',
        kml: 'geodesiaKmlFileInput',
        dxf: 'geodesiaDxfFileInput',
      }
      const refName = inputRefs[String(type || '').toLowerCase()]
      return refName ? this.$refs[refName] : null
    },
    openGeodesiaFilePicker(type) {
      const input = this.getGeodesiaFileInputRef(type)
      if (!input) return
      input.value = ''
      input.click()
    },
    getGeodesiaReplaceConfirmation(type) {
      const normalizedType = String(type || '').toLowerCase()
      const confirmationMap = {
        jxl: {
          flag: 'has_jxl',
          message: 'هل أنت متأكد من تحديث ملف JXL لهذا المشروع؟',
        },
        rw5: {
          flag: 'has_rw5',
          message: 'هل أنت متأكد من تحديث ملف RW5 لهذا المشروع؟',
        },
        raw: {
          flag: 'has_raw',
          message: 'هل أنت متأكد من تحديث ملف RAW لهذا المشروع؟',
        },
      }
      const confirmation = confirmationMap[normalizedType]
      if (!confirmation || !this.project || !this.project[confirmation.flag]) return null
      return confirmation.message
    },
    handleGeodesiaImportClick(type) {
      const normalizedType = String(type || '').toLowerCase()
      const confirmationMessage = this.getGeodesiaReplaceConfirmation(normalizedType)
      if (confirmationMessage) {
        this.$bvModal.msgBoxConfirm(
          confirmationMessage,
          {
            title: 'تأكيد التحديث',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: 'نعم، تحديث',
            cancelTitle: 'إلغاء',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          },
        ).then(value => {
          if (value) {
            this.openGeodesiaFilePicker(normalizedType)
          }
        }).catch(() => {})
        return
      }
      this.openGeodesiaFilePicker(normalizedType)
    },
    isGeodesiaSurveyFile(type, file) {
      if (!file || !file.name) return false
      const extensionMap = {
        jxl: '.jxl',
        rw5: '.rw5',
        raw: '.raw',
        kmz: '.kmz',
        kml: '.kml',
        dxf: '.dxf',
      }
      const extension = extensionMap[String(type || '').toLowerCase()]
      if (!extension) return false
      return file.name.toLowerCase().endsWith(extension)
    },
    getGeodesiaSurveyFileField(type) {
      const fieldMap = {
        jxl: 'jxl_file',
        rw5: 'rw5_file',
        raw: 'raw_file',
        kmz: 'kmz_file',
        kml: 'kml_file',
        dxf: 'dxf_file',
        geodesia_sheet: 'geodesia_sheet_file',
      }
      return fieldMap[String(type || '').toLowerCase()] || null
    },
    getGeodesiaSurveyImportApi(type) {
      const apiMap = {
        jxl: geodesiaApi.importJxlFile,
        rw5: geodesiaApi.importRw5File,
        raw: geodesiaApi.importRawFile,
        kmz: geodesiaApi.importKmzFile,
        kml: geodesiaApi.importKmlFile,
        dxf: geodesiaApi.importDxfFile,
      }
      return apiMap[String(type || '').toLowerCase()] || null
    },
    getGeodesiaSurveyExtensionMessage(type) {
      const messageMap = {
        jxl: 'يجب اختيار ملف بصيغة .jxl فقط',
        rw5: 'يجب اختيار ملف بصيغة .rw5 فقط',
        raw: 'يجب اختيار ملف بصيغة .raw فقط',
        kmz: 'يجب اختيار ملف بصيغة .kmz فقط',
        kml: 'يجب اختيار ملف بصيغة .kml فقط',
        dxf: 'يجب اختيار ملف بصيغة .dxf فقط',
      }
      return messageMap[String(type || '').toLowerCase()] || 'صيغة الملف غير مدعومة'
    },
    extractGeodesiaImportError(error, type) {
      const duplicateMessage = 'الملف المرفق موجود بالفعل بهذا الاسم برجاء استخدام اسم اخر'
      const fieldName = this.getGeodesiaSurveyFileField(type)
      const errorData = error?.response?.data || error?.data || error
      const fieldErrors = fieldName && errorData?.errors?.[fieldName]
      if (Array.isArray(fieldErrors) && fieldErrors.length) {
        return fieldErrors[0]
      }
      if (typeof errorData?.message === 'string' && errorData.message.trim()) {
        const normalizedType = String(type || '').toLowerCase()
        if (normalizedType === 'geodesia_sheet') {
          const mapped = this.geodesiaSheetMessageKeyToText(errorData.message.trim())
          if (mapped) return mapped
        }
        if (errorData.message.includes('موجود بالفعل')) {
          return duplicateMessage
        }
        return errorData.message
      }
      if (typeof errorData === 'string' && errorData.trim()) {
        return errorData
      }
      return 'حدث خطأ أثناء استيراد الملف'
    },
    geodesiaSheetMessageKeyToText(key) {
      const map = {
        no_points_found_in_geodesia_sheet: 'تمت قراءة الورقة ولم يُعثر على صفوف شرق/شمال صالحة.',
        failed_to_read_file_content: 'تعذر قراءة الملف أو الملف فارغ.',
        failed_to_import_geodesia_sheet_file: 'فشل استيراد ملف الجدول على الخادم.',
      }
      return map[key] || null
    },
    formatGeodesiaSheetPointError(rowErr) {
      if (rowErr == null) return ''
      if (typeof rowErr === 'string') return rowErr
      if (typeof rowErr === 'object') {
        const label = rowErr.point_name != null ? rowErr.point_name : rowErr.id
        const body = rowErr.message || rowErr.error || rowErr.reason
        if (label != null && body) return `${label}: ${body}`
        if (body) return String(body)
        try {
          return JSON.stringify(rowErr)
        } catch (e) {
          return String(rowErr)
        }
      }
      return String(rowErr)
    },
    resolveGeodesiaSheetHttpError(err) {
      const errorData = err?.response?.data
      const fieldErr = errorData?.errors?.geodesia_sheet_file
      if (fieldErr) {
        return Array.isArray(fieldErr) ? fieldErr[0] : fieldErr
      }
      const msg = typeof errorData?.message === 'string' ? errorData.message.trim() : ''
      if (msg) {
        const mapped = this.geodesiaSheetMessageKeyToText(msg)
        if (mapped) return mapped
        return msg
      }
      return this.extractGeodesiaImportError(err, 'geodesia_sheet')
    },
    onGeodesiaSheetFileInput(file) {
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      if (!file || !file.name) return
      const lower = file.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        this.$nextTick(() => {
          this.geodesiaSheetFile = null
        })
      }
    },
    resetGeodesiaSheetImport() {
      this.geodesiaSheetFile = null
      this.geodesiaSheetImportError = null
      this.importingGeodesiaSheet = false
    },
    async submitGeodesiaSheetImport() {
      if (!this.geodesiaSheetFile || !this.projectId) {
        this.geodesiaSheetImportError = 'معرف المشروع أو الملف غير متاح'
        return
      }
      const lower = this.geodesiaSheetFile.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        return
      }
      this.importingGeodesiaSheet = true
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      try {
        await this.ensureMapReady()
        const response = await geodesiaApi.importGeodesiaSheetFile(this.geodesiaSheetFile, this.projectId)
        if (response && response.success) {
          const importData = response.data || {}
          this.geodesiaSheetImportResult = importData
          this.showGeodesiaSheetImportModal = false
          this.notifyGeodesiaImportSuccess(importData, response.message)
          this.previewGeodesiaCoordinatesOnMap(importData.coordinates, 'geodesia_sheet')
          this.project.has_geodesia_sheet = true
          await this.$nextTick()
          await this.$nextTick()
          try {
            this.view?.resize?.()
          } catch (e) {
            // ignore
          }
          if (this.$refs.mapContainer) {
            try {
              this.$refs.mapContainer.scrollIntoView({ behavior: 'smooth', block: 'center' })
            } catch (e) {
              // ignore unsupported environments
            }
          }
        } else {
          this.geodesiaSheetImportError = this.extractGeodesiaImportError(response, 'geodesia_sheet')
        }
      } catch (error) {
        console.error('Failed to import Geodesia sheet file:', error)
        this.geodesiaSheetImportError = this.resolveGeodesiaSheetHttpError(error)
      } finally {
        this.importingGeodesiaSheet = false
        this.showGeodesiaSheetImportModal = false
      }
    },
    showGeodesiaImportToast({ variant, title, text, icon }) {
      if (!this.$toast) return
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          variant,
          icon,
        },
      })
    },
    buildGeodesiaImportResultMessage(importData) {
      const storedCount = Number(importData?.stored_points_count || 0)
      const parsedCount = Number(importData?.parsed_points_count || 0)
      const errorsCount = Number(importData?.errors_count || 0)
      const lines = []
      if (importData?.file_name) {
        lines.push(`اسم الملف: ${importData.file_name}`)
      }
      if (importData?.file_updated) {
        lines.push('تم استبدال ملف سابق بنفس الاسم.')
      }
      lines.push(`النقاط المقروءة: ${parsedCount} | المحفوظة: ${storedCount}`)
      if (importData?.project_id) {
        lines.push(`تم ربط الملف بالمشروع: ${importData.project_id}`)
      }
      if (errorsCount > 0 && Array.isArray(importData?.errors) && importData.errors.length) {
        const previewErrors = importData.errors.slice(0, 3).join('؛ ')
        lines.push(`أخطاء جزئية (${errorsCount}): ${previewErrors}`)
        if (importData.errors.length > 3) {
          lines.push('...')
        }
      }
      return lines.join('\n')
    },
    notifyGeodesiaImportSuccess(importData, responseMessage) {
      const errorsCount = Number(importData?.errors_count || 0)
      this.showGeodesiaImportToast({
        variant: errorsCount > 0 ? 'warning' : 'success',
        title: errorsCount > 0 ? 'استيراد جزئي' : 'تم الاستيراد بنجاح',
        text: this.buildGeodesiaImportResultMessage(importData) || responseMessage,
        icon: errorsCount > 0 ? 'AlertTriangleIcon' : 'CheckIcon',
      })
    },
    notifyGeodesiaImportError(message) {
      this.showGeodesiaImportToast({
        variant: 'danger',
        title: 'فشل الاستيراد',
        text: message,
        icon: 'XIcon',
      })
    },
    extractProjectSurveyFileError(error) {
      const errorData = error?.response?.data || error?.data || error
      if (errorData?.errors) {
        const firstFieldError = Object.values(errorData.errors).find(value => Array.isArray(value) && value.length)
        if (firstFieldError) return firstFieldError[0]
      }
      if (typeof errorData?.message === 'string' && errorData.message.trim()) {
        return errorData.message
      }
      return 'تعذر جلب ملفات المسح للمشروع'
    },
    getLatestProjectSurveyFile(files) {
      if (!Array.isArray(files) || !files.length) return null
      return [...files].sort((left, right) => {
        const leftTime = new Date(left?.created_at || 0).getTime()
        const rightTime = new Date(right?.created_at || 0).getTime()
        return rightTime - leftTime
      })[0]
    },
    async handleProjectSurveyFilePreview(type) {
      const normalizedType = String(type || '').toLowerCase()
      if (!this.projectId) {
        this.$toast?.warning?.('معرف المشروع غير متاح')
        return
      }

      this.previewingProjectSurveyFileType = normalizedType
      try {
        await this.ensureMapReady()
        const response = await geodesiaApi.getProjectSurveyFile(this.projectId, normalizedType)
        if (!response || !response.success) {
          this.notifyGeodesiaImportError(this.extractProjectSurveyFileError(response))
          return
        }

        const data = response.data || {}
        const filesCount = Number(data.files_count || 0)
        if (!filesCount || !Array.isArray(data.files) || !data.files.length) {
          this.$toast?.warning?.('لا توجد ملفات مساحية لهذا النوع في المشروع')
          return
        }

        const latestFile = this.getLatestProjectSurveyFile(data.files)
        const coordinates = latestFile?.coordinates || []
        const previewPoints = this.normalizeGeodesiaPreviewPoints(coordinates, normalizedType)
        if (!previewPoints.length) {
          this.$toast?.warning?.('لا توجد إحداثيات صالحة للمعاينة على الخريطة')
          return
        }
        this.previewGeodesiaCoordinatesOnMap(coordinates, normalizedType)

        const pointsCount = previewPoints.length
        const fileName = latestFile?.file_name || normalizedType.toUpperCase()
        this.showGeodesiaImportToast({
          variant: 'success',
          title: 'تم عرض النقاط',
          text: `تم عرض ${pointsCount} نقطة من ${fileName}`,
          icon: 'EyeIcon',
        })
      } catch (error) {
        console.error(`Failed to preview ${normalizedType} project survey file:`, error)
        this.notifyGeodesiaImportError(this.extractProjectSurveyFileError(error))
      } finally {
        this.previewingProjectSurveyFileType = null
      }
    },
    isValidMapCoordinate(latitude, longitude) {
      if (latitude == null || longitude == null) return false
      const lat = Number(latitude)
      const lng = Number(longitude)
      if (Number.isNaN(lat) || Number.isNaN(lng)) return false
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return false
      return true
    },
    normalizeGeodesiaPreviewPoints(coordinates, type) {
      const normalizedType = String(type || '').toLowerCase()
      return (coordinates || []).map(item => {
        const rawLat = item?.latitude ?? item?.lat
        const rawLng = item?.longitude ?? item?.lng
        if (!this.isValidMapCoordinate(rawLat, rawLng)) return null
        const longitude = Number(rawLng)
        const latitude = Number(rawLat)
        let label = ''
        if (normalizedType === 'rw5') {
          label = item?.point_number != null ? String(item.point_number) : ''
        } else {
          const name = item?.point_name
          if (name != null && String(name).trim() !== '') {
            label = String(name)
          } else if (normalizedType === 'geodesia_sheet' && item?.id != null) {
            label = String(item.id)
          }
        }
        return {
          longitude,
          latitude,
          label,
        }
      }).filter(Boolean)
    },
    previewGeodesiaCoordinatesOnMap(coordinates, type) {
      const points = this.normalizeGeodesiaPreviewPoints(coordinates, type)
      if (!points.length) {
        this.$toast?.warning?.('لا توجد إحداثيات صالحة للمعاينة على الخريطة')
        return
      }
      if (this.importedPointsLayer) {
        this.importedPointsLayer.removeAll()
      }
      this.plotImportedPoints(points, type)
    },
    async onGeodesiaSurveyFileSelected(type, event) {
      const file = event?.target?.files?.[0]
      if (!file) return

      const normalizedType = String(type || '').toLowerCase()

      if (!this.isGeodesiaSurveyFile(normalizedType, file)) {
        this.notifyGeodesiaImportError(this.getGeodesiaSurveyExtensionMessage(normalizedType))
        if (event?.target) event.target.value = ''
        return
      }

      const importApi = this.getGeodesiaSurveyImportApi(normalizedType)
      if (typeof importApi !== 'function') {
        this.notifyGeodesiaImportError('واجهة الاستيراد غير متاحة')
        if (event?.target) event.target.value = ''
        return
      }

      this.importingGeodesiaSurveyFile = true
      this.geodesiaImportingType = normalizedType
      try {
        await this.ensureMapReady()
        const response = await importApi.call(geodesiaApi, file, this.projectId)
        if (response && response.success) {
          const importData = response.data || {}
          this.notifyGeodesiaImportSuccess(importData, response.message)
          this.previewGeodesiaCoordinatesOnMap(importData.coordinates, normalizedType)
          if (importData.project_id) {
            const layerKeyByType = {
              jxl: 'jxlCoordinates',
              rw5: 'jxlRw5Coordinates',
              raw: 'jxlRawCoordinates',
            }
            const layerKey = layerKeyByType[normalizedType]
            if (layerKey) {
              this.layerVisibility[layerKey] = true
              await this.loadGeodesiaMapLayer(layerKey, { force: true })
            }
          }
        } else {
          this.notifyGeodesiaImportError(this.extractGeodesiaImportError(response, normalizedType))
        }
      } catch (error) {
        console.error(`Failed to import ${normalizedType} file:`, error)
        this.notifyGeodesiaImportError(this.extractGeodesiaImportError(error, normalizedType))
      } finally {
        this.importingGeodesiaSurveyFile = false
        this.geodesiaImportingType = null
        if (event?.target) event.target.value = ''
      }
    },
    async onImportFileChange(fileType, event) {
      const file = event?.target?.files?.[0]
      if (!file) return

      this.importingMapFiles = true
      try {
        await this.ensureMapReady()
        const points = await this.extractPointsFromFile(fileType, file)
        if (!points.length) {
          this.$toast?.warning?.('لم يتم العثور على نقاط صالحة داخل الملف')
          return
        }
        this.plotImportedPoints(points, fileType)
        this.$toast?.success?.(`تم استيراد ${points.length} نقطة من الملف ${file.name}`)
      } catch (error) {
        console.error(`Failed to import ${fileType} file:`, error)
        this.$toast?.error?.(`تعذر استيراد ملف ${String(fileType).toUpperCase()}`)
      } finally {
        this.importingMapFiles = false
        if (event?.target) event.target.value = ''
      }
    },
    async extractPointsFromFile(fileType, file) {
      const normalizedType = String(fileType || '').toLowerCase()
      if (normalizedType === 'kml') {
        const text = await this.readFileAsText(file)
        return this.extractPointsFromKmlText(text)
      }
      if (normalizedType === 'kmz') {
        return this.extractPointsFromKmzFile(file)
      }
      const text = await this.readFileAsText(file)
      return this.extractPointsFromPlainText(text)
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result || ''))
        reader.onerror = () => reject(new Error('Failed to read file'))
        reader.readAsText(file)
      })
    },
    normalizeCoordinates(rawPoints) {
      const points = []
      ;(rawPoints || []).forEach(item => {
        if (!this.isValidMapCoordinate(item?.latitude, item?.longitude)) return
        points.push({
          longitude: Number(item.longitude),
          latitude: Number(item.latitude),
        })
      })
      return points
    },
    extractPointsFromKmlText(kmlText) {
      if (!kmlText) return []
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(kmlText, 'text/xml')
      const coordinateNodes = Array.from(xmlDoc.getElementsByTagName('coordinates'))
      const rawPoints = []

      coordinateNodes.forEach(node => {
        const content = String(node?.textContent || '').trim()
        if (!content) return
        content.split(/\s+/).forEach(tuple => {
          const parts = tuple.split(',')
          if (parts.length < 2) return
          rawPoints.push({
            longitude: Number(parts[0]),
            latitude: Number(parts[1]),
          })
        })
      })

      return this.normalizeCoordinates(rawPoints)
    },
    async extractPointsFromKmzFile(file) {
      if (!this.map) {
        throw new Error('KMLLayer is not available for KMZ parsing')
      }
      const kmlModule = await loadArcgisModules(['esri/layers/KMLLayer'])
      const KMLLayerCtor = kmlModule?.[0]
      const KMLLayerClass = typeof KMLLayerCtor === 'function' ? KMLLayerCtor : KMLLayerCtor?.default
      if (typeof KMLLayerClass !== 'function') {
        throw new Error('Invalid KMLLayer module')
      }

      const blobUrl = URL.createObjectURL(file)
      const kmzLayer = new KMLLayerClass({ url: blobUrl, visible: false })
      const rawPoints = []

      try {
        this.map.add(kmzLayer)
        await kmzLayer.load()

        const collectFromLayer = layer => {
          if (!layer) return
          const graphics = layer.graphics?.toArray ? layer.graphics.toArray() : layer.graphics || []
          graphics.forEach(graphic => {
            if (graphic?.geometry?.type !== 'point') return
            rawPoints.push({
              longitude: Number(graphic.geometry.longitude),
              latitude: Number(graphic.geometry.latitude),
            })
          })
          const children = layer.layers?.toArray ? layer.layers.toArray() : layer.layers || []
          children.forEach(collectFromLayer)
          const sublayers = layer.sublayers?.toArray ? layer.sublayers.toArray() : layer.sublayers || []
          sublayers.forEach(collectFromLayer)
        }

        collectFromLayer(kmzLayer)
      } finally {
        this.map.remove(kmzLayer)
        kmzLayer.destroy?.()
        URL.revokeObjectURL(blobUrl)
      }

      return this.normalizeCoordinates(rawPoints)
    },
    extractPointsFromPlainText(content) {
      if (!content) return []
      const rawPoints = []
      const lines = content.split(/\r?\n/)

      lines.forEach(line => {
        const numbers = (line.match(/-?\d+(?:\.\d+)?/g) || []).map(Number)
        if (numbers.length < 2) return

        for (let i = 0; i < numbers.length - 1; i += 1) {
          const first = numbers[i]
          const second = numbers[i + 1]
          if (first >= -180 && first <= 180 && second >= -90 && second <= 90) {
            rawPoints.push({ longitude: first, latitude: second })
            return
          }
          if (first >= -90 && first <= 90 && second >= -180 && second <= 180) {
            rawPoints.push({ longitude: second, latitude: first })
            return
          }
        }
      })

      return this.normalizeCoordinates(rawPoints)
    },
    extractPointsFromJxlText(content) {
      if (!content) return []
      const text = String(content).trim()
      try {
        const parsed = JSON.parse(text)
        const points = Array.isArray(parsed?.points) ? parsed.points : Array.isArray(parsed) ? parsed : []
        const rawPoints = points.map(point => {
          const coordinates = point?.geometry?.coordinates || point?.coordinates
          if (Array.isArray(coordinates) && coordinates.length >= 2) {
            return {
              longitude: Number(coordinates[0]),
              latitude: Number(coordinates[1]),
            }
          }
          return {
            longitude: Number(point?.longitude ?? point?.lng),
            latitude: Number(point?.latitude ?? point?.lat),
          }
        })
        return this.normalizeCoordinates(rawPoints)
      } catch (error) {
        return this.extractPointsFromPlainText(text)
      }
    },
    plotImportedPoints(points, fileType) {
      if (!this.arcgisModules?.Graphic) return
      const { Graphic } = this.arcgisModules
      const type = String(fileType || '').toLowerCase()
      const targetLayer = this.importedPointsLayer
      if (!targetLayer) return

      points.forEach(point => {
        targetLayer.add(new Graphic({
          geometry: {
            type: 'point',
            longitude: point.longitude,
            latitude: point.latitude,
            spatialReference: { wkid: 4326 },
          },
          symbol: getSurveyPointArcgisSymbol(type, 8),
          attributes: {
            source: type,
            label: point.label || '',
          },
        }))
      })

      this.fitMapViewToImportedPoints(points)
    },
    fitMapViewToImportedPoints(points) {
      if (!this.view || !points?.length) return
      if (points.length === 1) {
        this.view.goTo({
          center: [points[0].longitude, points[0].latitude],
          zoom: 18,
        }).catch(() => {})
        return
      }
      const ExtentCtor = this.arcgisModules?.Extent
      if (typeof ExtentCtor !== 'function') {
        this.view.goTo({
          center: [points[0].longitude, points[0].latitude],
          zoom: 16,
        }).catch(() => {})
        return
      }
      const xs = points.map(p => p.longitude)
      const ys = points.map(p => p.latitude)
      const xmin = Math.min(...xs)
      const xmax = Math.max(...xs)
      const ymin = Math.min(...ys)
      const ymax = Math.max(...ys)
      const padX = Math.max((xmax - xmin) * 0.08, 0.0002)
      const padY = Math.max((ymax - ymin) * 0.08, 0.0002)
      const extent = new ExtentCtor({
        xmin: xmin - padX,
        ymin: ymin - padY,
        xmax: xmax + padX,
        ymax: ymax + padY,
        spatialReference: { wkid: 4326 },
      })
      this.view.goTo(extent, { animate: true }).catch(() => {})
    },
    async loadMapAllData() {
      if (!this.arcgisModules) return
      const { Graphic } = this.arcgisModules
      try {
        const response = await mapLibraryApi.getAllMapData({
          chunk_size: 100000,
          include_administrative_boundaries: 0,
        })
        const data = response?.data && typeof response.data === 'object' ? response.data : response
        const projects = data?.projects || []
        const mapLibraries = data?.map_libraries || []
        const fixedPoints = data?.fixed_points || []

        this.projectsLayer.removeAll()
        this.mapLibrariesLayer.removeAll()
        this.fixedPointsLayer.removeAll()

        projects.forEach(project => {
          const coords = project?.geometry?.coordinates
          if (!Array.isArray(coords) || !Array.isArray(coords[0])) return
          const rings = coords[0].map(p => [Number(p[0]), Number(p[1])])
          if (rings.length < 3) return
          this.projectsLayer.add(new Graphic({
            geometry: {
              type: 'polygon',
              rings,
              spatialReference: { wkid: 4326 },
            },
            symbol: {
              type: 'simple-fill',
              color: [255, 0, 0, 0.18],
              outline: { type: 'simple-line', color: [255, 0, 0, 1], width: 1.5 },
            },
            attributes: project?.attributes || {},
          }))
        })

        mapLibraries.forEach(item => {
          const coords = item?.geometry?.coordinates || item?.geometry?.rings || item?.polygon
          const ring = Array.isArray(coords) && Array.isArray(coords[0]) && Array.isArray(coords[0][0]) ? coords[0] : coords
          if (!Array.isArray(ring) || ring.length < 3) return
          this.mapLibrariesLayer.add(new Graphic({
            geometry: {
              type: 'polygon',
              rings: [ring.map(p => [Number(p[0]), Number(p[1])])],
              spatialReference: { wkid: 4326 },
            },
            symbol: {
              type: 'simple-fill',
              color: [255, 165, 0, 0.14],
              outline: { type: 'simple-line', color: [255, 140, 0, 1], width: 1.5 },
            },
            attributes: item?.attributes || {},
          }))
        })

        fixedPoints.forEach(point => {
          const lat = Number(point?.attributes?.latitude || point?.latitude)
          const lng = Number(point?.attributes?.longitude || point?.longitude)
          if (!lat || !lng || Number.isNaN(lat) || Number.isNaN(lng)) return
          this.fixedPointsLayer.add(new Graphic({
            geometry: {
              type: 'point',
              longitude: lng,
              latitude: lat,
              spatialReference: { wkid: 4326 },
            },
            symbol: {
              type: 'simple-marker',
              style: 'circle',
              color: [0, 153, 255, 0.85],
              size: 7,
              outline: { color: [255, 255, 255, 0.9], width: 1.5 },
            },
            attributes: point?.attributes || point || {},
          }))
        })
      } catch (error) {
        console.error('Failed to load map all-data:', error)
      }
    },
    async loadAllAdministrativeBoundaryTypes({ force = false } = {}) {
      if (!this.canViewAdministrativeBoundaries) return
      await Promise.all(
        ADMINISTRATIVE_BOUNDARY_TYPES.map(item => (
          this.loadAdministrativeBoundaryType(item.type, { force })
        )),
      )
    },
    async loadAdministrativeBoundaries({ force = false, type = null } = {}) {
      if (type) {
        await this.loadAdministrativeBoundaryType(type, { force })
        return
      }
      await this.loadAllAdministrativeBoundaryTypes({ force })
    },
    async loadAdministrativeBoundaryType(type, { force = false } = {}) {
      const layer = this.administrativeBoundaryLayers?.[type]
      if (!this.canViewAdministrativeBoundaries || !this.arcgisModules || !layer) {
        return
      }

      const { Graphic } = this.arcgisModules
      try {
        const year = this.administrativeBoundariesYear || DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR
        const featureCollection = await fetchAdministrativeBoundariesGeoJson(year, { force, type })
        const items = normalizeAdministrativeBoundaryItems(featureCollection)
        const graphics = mapAdministrativeBoundaryItemsToGraphics(items, type)

        layer.removeAll()
        graphics.forEach(graphic => {
          layer.add(new Graphic(graphic))
        })

        layer.visible = this.layerVisibility[administrativeBoundaryLayerKey(type)] === true
      } catch (error) {
        console.error(`Failed to load administrative boundaries (${type}):`, error)
      }
    },
    async loadVrsData() {
      return this.loadGeodesiaMapLayer('vrsCoordinates')
    },
    async loadJxlData() {
      return this.loadVisibleGeodesiaLayers({ force: true })
    },
    cancelGeodesiaLayerRequest(layerKey) {
      const source = this.geodesiaLayerCancels?.[layerKey]
      if (!source) return
      source.cancel('layer-toggled-off')
      this.$delete(this.geodesiaLayerCancels, layerKey)
    },
    cancelAllGeodesiaLayerRequests() {
      Object.keys(this.geodesiaLayerCancels || {}).forEach(key => {
        this.cancelGeodesiaLayerRequest(key)
      })
    },
    notifyGeodesiaLayerTruncated(payload) {
      if (!isGeodesiaLayerTruncated(payload) || !this.$toast?.warning) return
      this.$toast.warning(GEODESIA_LAYER_TRUNCATED_MESSAGE)
    },
    async loadVisibleGeodesiaLayers({ force = false } = {}) {
      const tasks = GEODESIA_MAP_LAYER_KEYS
        .filter(key => this.layerVisibility[key])
        .map(key => this.loadGeodesiaMapLayer(key, { force }))
      await Promise.all(tasks)
    },
    getGeodesiaGraphicsLayer(layerKey) {
      const layerMap = {
        vrsCoordinates: this.vrsCoordinatesLayer,
        jxlCoordinates: this.jxlCoordinatesLayer,
        jxlRw5Coordinates: this.jxlRw5CoordinatesLayer,
        jxlRawCoordinates: this.jxlRawCoordinatesLayer,
        jxlPolygons: this.jxlPolygonsLayer,
        jxlBaselineLines: this.jxlBaselineLinesLayer,
      }
      return layerMap[layerKey] || null
    },
    async loadGeodesiaMapLayer(layerKey, { force = false } = {}) {
      if (!GEODESIA_MAP_LAYER_KEYS.includes(layerKey)) return
      if (this.geodesiaLayerLoading[layerKey]) return
      if (!force && this.geodesiaLayerLoaded[layerKey]) return

      const layer = this.getGeodesiaGraphicsLayer(layerKey)
      if (!this.arcgisModules || !layer) return

      this.cancelGeodesiaLayerRequest(layerKey)
      this.$set(this.geodesiaLayerLoading, layerKey, true)
      const cancelSource = createGeodesiaLayerCancelSource()
      this.$set(this.geodesiaLayerCancels, layerKey, cancelSource)

      try {
        const response = await geodesiaApi.getGeodesiaMapLayer(layerKey, {}, { cancelToken: cancelSource.token })
        const payload = unwrapGeodesiaLayerPayload(response)
        const features = getGeodesiaLayerFeatures(payload, layerKey)
        layer.removeAll()

        if (layerKey === 'jxlPolygons') {
          this.drawGeodesiaPolygons(layer, features)
        } else if (layerKey === 'jxlBaselineLines') {
          this.drawGeodesiaBaselineLines(layer, features)
        } else {
          this.drawGeodesiaPoints(layer, features, GEODESIA_LAYER_SOURCE[layerKey] || 'vrs')
        }

        this.notifyGeodesiaLayerTruncated(payload)
        this.$set(this.geodesiaLayerLoaded, layerKey, true)
      } catch (error) {
        if (isGeodesiaLayerRequestCanceled(error)) {
          this.$set(this.geodesiaLayerLoaded, layerKey, false)
          return
        }
        console.error(`Failed to load ${layerKey} data:`, error)
        this.$toast?.error?.(geodesiaLayerErrorMessage(error, layerKey) || GEODESIA_LAYER_ERROR_MESSAGE[layerKey])
        this.$set(this.geodesiaLayerLoaded, layerKey, false)
      } finally {
        this.$set(this.geodesiaLayerLoading, layerKey, false)
        if (this.geodesiaLayerCancels[layerKey] === cancelSource) {
          this.$delete(this.geodesiaLayerCancels, layerKey)
        }
      }
    },
    drawGeodesiaPoints(layer, points, sourceKey) {
      if (!layer || !this.arcgisModules || !Array.isArray(points)) return
      const { Graphic } = this.arcgisModules
      const isVrs = sourceKey === 'vrs'
      points.forEach(point => {
        const coordinates = point?.geometry?.coordinates
        if (!Array.isArray(coordinates) || coordinates.length < 2) return
        const lng = Number(coordinates[0])
        const lat = Number(coordinates[1])
        if (!this.isValidMapCoordinate(lat, lng)) return
        layer.add(new Graphic({
          geometry: {
            type: 'point',
            longitude: lng,
            latitude: lat,
            spatialReference: { wkid: 4326 },
          },
          symbol: isVrs
            ? {
              type: 'simple-marker',
              style: 'circle',
              color: [226, 119, 40, 0.8],
              size: 8,
              outline: { color: [255, 255, 255, 0.9], width: 2 },
            }
            : getSurveyPointArcgisSymbol(sourceKey, 8),
          attributes: { ...(point.attributes || {}), source: isVrs ? undefined : sourceKey },
        }))
      })
    },
    drawGeodesiaPolygons(layer, polygons) {
      if (!layer || !this.arcgisModules || !Array.isArray(polygons)) return
      const { Graphic } = this.arcgisModules
      polygons.forEach(feature => {
        const rings = feature?.geometry?.coordinates
        if (!Array.isArray(rings) || !Array.isArray(rings[0]) || rings[0].length < 3) return
        const ring = rings[0]
          .filter(coord => Array.isArray(coord) && coord.length >= 2)
          .map(coord => [Number(coord[0]), Number(coord[1])])
          .filter(coord => this.isValidMapCoordinate(coord[1], coord[0]))
        if (ring.length < 3) return
        const color = hexColorToRgb(feature?.attributes?.color, [0, 200, 0])
        layer.add(new Graphic({
          geometry: {
            type: 'polygon',
            rings: [ring],
            spatialReference: { wkid: 4326 },
          },
          symbol: {
            type: 'simple-fill',
            color: [...color, 0.25],
            outline: { color: [...color, 0.9], width: 2 },
          },
          attributes: feature.attributes || {},
        }))
      })
    },
    drawGeodesiaBaselineLines(layer, lines) {
      if (!layer || !this.arcgisModules || !Array.isArray(lines)) return
      const { Graphic } = this.arcgisModules
      lines.forEach(feature => {
        const coords = feature?.geometry?.coordinates
        if (!Array.isArray(coords) || coords.length < 2) return
        const path = coords
          .filter(coord => Array.isArray(coord) && coord.length >= 2)
          .map(coord => [Number(coord[0]), Number(coord[1])])
          .filter(coord => this.isValidMapCoordinate(coord[1], coord[0]))
        if (path.length < 2) return
        const color = hexColorToRgb(feature?.attributes?.color, [255, 0, 0])
        layer.add(new Graphic({
          geometry: {
            type: 'polyline',
            paths: [path],
            spatialReference: { wkid: 4326 },
          },
          symbol: {
            type: 'simple-line',
            color: [...color, 0.9],
            width: 2,
          },
          attributes: feature.attributes || {},
        }))
      })
    },
    async loadSpatialData() {
      this.loadingLocations = true
      try {
        await this.$store.dispatch('projects/getSpatialData', { id: this.projectId })
        if (!this.selectedLocationId && this.locations.length) {
          this.selectedLocationId = this.locations[0].id
        }
        this.renderExistingPolygons()
      } catch (error) {
        this.$toast?.error?.(error.response?.data?.message || 'تعذر تحميل بيانات الاحداثيات')
      } finally {
        this.loadingLocations = false
      }
    },
    resetAddLocationForm() {
      this.addLocationForm = {
        land_number: '',
        block_number: '',
        area: null,
        activity: null,
        situation: null,
        code: '',
        location_notes: '',
      }
      this.editLocationId = null
      this.addingLocation = false
    },
    openAddLocationModal() {
      this.resetAddLocationForm()
      this.showAddLocationModal = true
    },
    openEditLocationModal() {
      if (!this.selectedLocation) return
      this.editLocationId = this.selectedLocation.id
      this.addLocationForm = {
        land_number: this.selectedLocation.land_number || '',
        block_number: this.selectedLocation.block_number || '',
        area: this.selectedLocation.area ?? null,
        activity: this.selectedLocation.activity ?? null,
        situation: this.selectedLocation.situation ?? null,
        code: this.selectedLocation.code != null ? String(this.selectedLocation.code) : '',
        location_notes: this.selectedLocation.location_notes || '',
      }
      this.showAddLocationModal = true
    },
    async submitLocationForm() {
      if (!this.addLocationForm.land_number || this.addingLocation) return

      this.addingLocation = true
      try {
        let payload = {
          query: {
            ...this.addLocationForm,
            project_id: this.projectId,
          },
        }
        if (this.editLocationId) {
          payload = { ...payload, id: this.editLocationId }
        }

        const response = await this.$store.dispatch('projects/addLocation', payload)
        this.$toast?.success?.(
          response?.message || (this.editLocationId ? 'تم تعديل القطعة بنجاح' : 'تم إضافة القطعة بنجاح'),
        )
        this.showAddLocationModal = false
        await this.loadSpatialData()

        const targetId = this.editLocationId || response?.data?.id || response?.data?.project_location?.id
        if (targetId) {
          this.selectedLocationId = targetId
          this.focusLocationOnMap(targetId)
        } else if (this.locations.length) {
          const fallbackId = this.locations[this.locations.length - 1].id
          this.selectedLocationId = fallbackId
          this.focusLocationOnMap(fallbackId)
        }
      } catch (error) {
        this.$toast?.error?.(
          error.response?.data?.message || (this.editLocationId ? 'تعذر تعديل القطعة' : 'تعذر إضافة القطعة'),
        )
      } finally {
        this.addingLocation = false
      }
    },
    async deleteSelectedLocation() {
      if (!this.selectedLocation || this.deletingLocation) return

      const confirmed = this.$swal
        ? await this.$swal({
          title: 'هل أنت متأكد من حذف القطعة؟',
          text: `سيتم حذف قطعة ${this.selectedLocation.land_number || this.selectedLocation.id}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'نعم، حذف',
          cancelButtonText: 'إلغاء',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
        }).then(result => !!result.isConfirmed)
        : window.confirm('هل أنت متأكد من حذف القطعة المحدد؟')

      if (!confirmed) return

      this.deletingLocation = true
      try {
        await this.$store.dispatch('projects/deleteProjectLocation', this.selectedLocation.id)
        this.$toast?.success?.('تم حذف القطعة بنجاح')
        await this.loadSpatialData()
        this.pendingPolygonCoordinates = []

        if (this.locations.length) {
          this.selectedLocationId = this.locations[0].id
          this.focusLocationOnMap(this.selectedLocationId)
        } else {
          this.selectedLocationId = null
        }
      } catch (error) {
        this.$toast?.error?.(error.response?.data?.message || 'تعذر حذف القطعة')
      } finally {
        this.deletingLocation = false
      }
    },
    onSelectedLocationChange() {
      this.$nextTick(() => {
        if (!this.view || !this.selectedLocationId) return
        this.focusLocationOnMap(this.selectedLocationId)
      })
    },
    focusLocationOnMap(locationId) {
      if (!this.view || !locationId) return

      const targetLocation = this.locations.find(location => Number(location.id) === Number(locationId))
      if (!targetLocation) return

      const targetGraphic = this.existingPolygonsLayer?.graphics?.find(
        graphic => Number(graphic?.attributes?.location_id) === Number(locationId),
      )
      if (targetGraphic) {
        this.view.goTo(targetGraphic).catch(() => {})
        return
      }

      const fieldsCoordinates = (targetLocation.coordinates || []).filter(c => c.type === 'fields')
      if (fieldsCoordinates.length >= 3 && this.arcgisModules?.Polygon) {
        const rings = [fieldsCoordinates.map(coord => [Number(coord.longitude), Number(coord.latitude)])]
        try {
          const polygon = new this.arcgisModules.Polygon({
            rings,
            spatialReference: { wkid: 4326 },
          })
          this.view.goTo(polygon).catch(() => {})
          return
        } catch (e) {
          // fall through to center / point
        }
      }

      const latitude = Number(targetLocation?.center_point?.latitude)
      const longitude = Number(targetLocation?.center_point?.longitude)
      if (Number.isFinite(latitude) && Number.isFinite(longitude) && !(latitude === 0 && longitude === 0)) {
        this.view.goTo({ center: [longitude, latitude], zoom: 19 }).catch(() => {})
        return
      }

      const list = Array.isArray(targetLocation.coordinates) ? targetLocation.coordinates : []
      const found = list.find(coord => {
        const la = Number(coord?.latitude)
        const ln = Number(coord?.longitude)
        return Number.isFinite(la) && Number.isFinite(ln) && !(la === 0 && ln === 0)
      })
      if (found) {
        this.view.goTo({ center: [Number(found.longitude), Number(found.latitude)], zoom: 19 }).catch(() => {})
      }
    },
    renderExistingPolygons() {
      if (!this.existingPolygonsLayer || !this.arcgisModules) return
      const { Graphic } = this.arcgisModules
      this.existingPolygonsLayer.removeAll()

      this.locations.forEach(location => {
        const fieldsCoordinates = (location.coordinates || []).filter(coord => coord.type === 'fields')
        if (fieldsCoordinates.length < 3) return

        const rings = [fieldsCoordinates.map(coord => [Number(coord.longitude), Number(coord.latitude)])]
        const graphic = new Graphic({
          geometry: {
            type: 'polygon',
            rings,
            spatialReference: { wkid: 4326 },
          },
          symbol: {
            type: 'simple-fill',
            color: [0, 128, 255, 0.15],
            outline: {
              color: [0, 128, 255, 1],
              width: 2,
            },
          },
          attributes: {
            location_id: location.id,
            land_number: location.land_number || location.id,
          },
          popupTemplate: {
            title: 'قطعة رقم {land_number}',
            content: 'موقع رقم: {location_id}',
          },
        })
        this.existingPolygonsLayer.add(graphic)
      })
    },
    fitMapToSpatialProjectData() {
      if (!this.view || !this.locations.length) return

      const polygonGraphics = []
      this.existingPolygonsLayer?.graphics?.forEach(graphic => polygonGraphics.push(graphic))
      if (polygonGraphics.length) {
        this.view.goTo(polygonGraphics).catch(() => {})
        return
      }

      for (let i = 0; i < this.locations.length; i += 1) {
        const location = this.locations[i]
        const lat = Number(location?.center_point?.latitude)
        const lng = Number(location?.center_point?.longitude)
        if (Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)) {
          this.view.goTo({ center: [lng, lat], zoom: 18 }).catch(() => {})
          return
        }
      }

      const coordsFromLocation = location => (Array.isArray(location?.coordinates) ? location.coordinates : [])
      for (let i = 0; i < this.locations.length; i += 1) {
        const found = coordsFromLocation(this.locations[i]).find(coord => {
          const la = Number(coord?.latitude)
          const ln = Number(coord?.longitude)
          return Number.isFinite(la) && Number.isFinite(ln) && !(la === 0 && ln === 0)
        })
        if (found) {
          this.view.goTo({ center: [Number(found.longitude), Number(found.latitude)], zoom: 18 }).catch(() => {})
          return
        }
      }
    },
    async saveDrawnCoordinates() {
      console.log('saveDrawnCoordinates', this.selectedLocationId, this.pendingPolygonCoordinates)
      if (!this.selectedLocationId || !this.pendingPolygonCoordinates.length) return
      this.savingCoordinates = true
      try {
        await this.$store.dispatch('projects/updateCoordinates', {
          id: this.selectedLocationId,
          query: {
            coordinates: this.pendingPolygonCoordinates,
            coordinates_type: 'fields',
          },
        })
        this.$toast?.success?.('تم حفظ الإحداثيات بنجاح')
        this.openEditLocationModal()
        await this.loadSpatialData()
        this.focusLocationOnMap(this.selectedLocationId)
        this.pendingPolygonCoordinates = []
      } catch (error) {
        this.$toast?.error?.(error.response?.data?.message || 'تعذر حفظ الإحداثيات')
      } finally {
        this.savingCoordinates = false
      }
    },
  },
  mounted() {
    this.onMapCollapseShown()
  },
  beforeDestroy() {
    this.cancelAllGeodesiaLayerRequests()
    if (this.visibilityCheckInterval) {
      clearInterval(this.visibilityCheckInterval)
      this.visibilityCheckInterval = null
    }
    destroyArcgisView(this.view)
    this.view = null
    this.map = null
    this.sketch = null
  },
}
</script>
<style scoped>
.natural-survey-map {
  width: 100%;
  height: 520px;
  border-radius: 8px;
}

.natural-survey-fieldset {
  min-width: 0;
  margin: 0.65rem 0 0.85rem;
  padding: 0.85rem 1rem 1rem;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  direction: ltr;
}

.natural-survey-fieldset > .natural-survey-fieldset__legend {
  float: none !important;
  display: table;
  width: auto !important;
  max-width: calc(100% - 1.5rem);
  margin: 0 0 0 0.75rem !important;
  padding: 0 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
  color: #5e5873;
  text-align: left;
  background-color: #fff;
}



.map-container-wrapper {
  position: relative;
}

.map-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 3;
  font-weight: 600;
}

.import-files-panel {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe7f3;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.import-files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
}

.geodesia-survey-import-actions {
  gap: 8px;
}

.geodesia-survey-import-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.geodesia-survey-existing-file {
  gap: 4px;
  font-size: 12px;
}

.geodesia-survey-preview-button {
  min-width: auto;
  line-height: 1;
  color: inherit;
}

.geodesia-survey-import-button {
  white-space: nowrap;
}

.geodesia-sheet-import-table-wrap {
  max-height: 320px;
  overflow: auto;
}

.import-file-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #1f2d3d;
  background: #fff;
  border: 1px solid #e3edf7;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease;
}

.import-file-item:hover {
  border-color: #b8d3ef;
  box-shadow: 0 3px 10px rgba(59, 130, 246, 0.12);
}

.import-file-item span {
  font-size: 12px;
  font-weight: 700;
  color: #0f2742;
}

.import-file-item input[type='file'] {
  width: 100%;
  color: #374151;
  font-size: 11px;
  background: #f8fafc;
  border: 1px dashed #c7d7ea;
  border-radius: 6px;
  padding: 4px;
}

.import-file-item input[type='file']:focus {
  outline: none;
  border-color: #4f9be6;
  box-shadow: 0 0 0 3px rgba(79, 155, 230, 0.2);
}

.import-file-item input[type='file']::file-selector-button {
  border: 0;
  border-radius: 6px;
  background: #2563eb;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 8px;
  margin-right: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.import-file-item input[type='file']::file-selector-button:hover {
  background: #1d4ed8;
}

.location-select {
  min-width: 220px;
}
</style>

<!-- Same as GeodesiaLab.vue: map UI nodes sit under the ArcGIS view DOM, so spinner/loading must be unscoped. -->
<style>
.home-location-button {
  margin-top: 4px;
}

.home-location-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #323232;
  line-height: 0;
}

.home-location-button--loading {
  pointer-events: none;
  opacity: 0.8;
}

.home-location-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #3498db;
  border-top-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation: home-location-spin 1s linear infinite;
}

@keyframes home-location-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>